import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import 'stream-browserify'; // see https://github.com/ericgundrum/pouch-websocket-sync-example/commit/2a4437b013092cc7b2cd84cf1499172c84a963a3

import 'subworkers'; // polyfill for https://bugs.chromium.org/p/chromium/issues/detail?id=31666

import url from 'url';
import ByteBuffer from 'bytebuffer';
import MumbleClient from 'mumble-client';
import WorkerBasedMumbleConnector from './worker-client';
import BufferQueueNode from 'web-audio-buffer-queue';
import mumbleConnect from 'mumble-client-websocket';
import audioContext from 'audio-context';
import ko from 'knockout';
import _dompurify from 'dompurify';
import keyboardjs from 'keyboardjs';
import anchorme from 'anchorme';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { ContinuousVoiceHandler, PushToTalkVoiceHandler, VADVoiceHandler, initVoice } from './voice';
import { initialize as localizationInitialize, translate } from './loc';

var dompurify = _dompurify(window);

window.ko = ko; // from: https://gist.github.com/haliphax/5379454

ko.extenders.scrollFollow = function (target, selector) {
  target.subscribe(function (chat) {
    // LOG TEMPORÁRIO — apague depois de depurar
    var last = chat[chat.length - 1];
    if (last) console.log('ITEM:', JSON.stringify(ko.toJS(last), null, 2));
    var el = document.querySelector(selector); // the scroll bar is all the way down, so we know they want to follow the text

    if (el.scrollTop == el.scrollHeight - el.clientHeight) {
      // have to push our code outside of this thread since the text hasn't updated yet
      setTimeout(function () {
        el.scrollTop = el.scrollHeight - el.clientHeight;
      }, 0);
    } else {
      // send notification
      if (Notification.permission == 'granted' && last.type != 'chat-message-self') {
        var sender = 'Mumble Server';
        if (last.user && last.user.name) sender = last.user.name();
        new Notification(sender, {
          body: dompurify.sanitize(last.message, {
            ALLOWED_TAGS: []
          })
        });
      }
    }
  });
  return target;
};

function sanitize(html) {
  return dompurify.sanitize(html, {
    ALLOWED_TAGS: ['br', 'b', 'i', 'u', 'a', 'span', 'p', 'img', 'center']
  });
}

var anchormeOptions = {
  // force target _blank attribute
  attributes: {
    target: "_blank"
  },
  // force https protocol except email
  protocol: function protocol(s) {
    if (anchorme.validate.email(s)) {
      return "mailto:";
    } else {
      return "https://";
    }
  }
};

function openContextMenu(event, contextMenu, target) {
  contextMenu.posX(event.clientX);
  contextMenu.posY(event.clientY);
  contextMenu.target(target);

  var closeListener = function closeListener(event) {
    // Always close, no matter where they clicked
    setTimeout(function () {
      // delay to allow click to be actually processed
      contextMenu.target(null);
      unregister();
    });
  };

  var unregister = function unregister() {
    return document.removeEventListener('click', closeListener);
  };

  document.addEventListener('click', closeListener);
  event.stopPropagation();
  event.preventDefault();
} // ===== Som do PTT (radio.wav) =====


var pttSound = new Audio('radio.wav');
pttSound.preload = 'auto';
pttSound.volume = 0.5; // ajuste 0..1

function playPttSound() {
  try {
    pttSound.currentTime = 0; // reinicia do começo a cada acionamento

    pttSound.play()["catch"](function () {}); // ignora bloqueio de autoplay
  } catch (e) {}
} // GUI


function ContextMenu() {
  var self = this;
  self.posX = ko.observable();
  self.posY = ko.observable();
  self.target = ko.observable();
}

function AddChannelDialog() {
  var self = this;
  self.channelName = ko.observable('');
  self.parentID = 0;
  self.visible = ko.observable(false);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);

  self.addchannel = function () {
    self.hide();
    ui.addchannel(self.channelName());
  };
}

function ConnectDialog() {
  var self = this;
  self.address = ko.observable('');
  self.port = ko.observable('');
  self.tokenToAdd = ko.observable('');
  self.selectedTokens = ko.observableArray([]);
  self.tokens = ko.observableArray([]);
  self.username = ko.observable('');
  self.password = ko.observable('');
  self.channelName = ko.observable('');
  self.joinOnly = ko.observable(false);
  self.visible = ko.observable(true);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);

  self.connect = function () {
    self.hide();

    if (ui.detectWebRTC) {
      ui.webrtc = true;
    }

    ui.connect(self.username(), self.address(), self.port(), self.tokens(), self.password(), self.channelName());
  };

  self.addToken = function () {
    if (self.tokenToAdd() != "" && self.tokens.indexOf(self.tokenToAdd()) < 0) {
      self.tokens.push(self.tokenToAdd());
    }

    self.tokenToAdd("");
  };

  self.removeSelectedTokens = function () {
    this.tokens.removeAll(this.selectedTokens());
    this.selectedTokens([]);
  };
}

function ConnectErrorDialog(connectDialog) {
  var self = this;
  self.type = ko.observable(0);
  self.reason = ko.observable('');
  self.username = connectDialog.username;
  self.password = connectDialog.password;
  self.joinOnly = connectDialog.joinOnly;
  self.visible = ko.observable(false);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);

  self.connect = function () {
    self.hide();
    connectDialog.connect();
  };
}

var ConnectionInfo = /*#__PURE__*/function () {
  function ConnectionInfo(ui) {
    var _this = this;

    _classCallCheck(this, ConnectionInfo);

    this._ui = ui;
    this.visible = ko.observable(false);
    this.serverVersion = ko.observable();
    this.latencyMs = ko.observable(NaN);
    this.latencyDeviation = ko.observable(NaN);
    this.remoteHost = ko.observable();
    this.remotePort = ko.observable();
    this.maxBitrate = ko.observable(NaN);
    this.currentBitrate = ko.observable(NaN);
    this.maxBandwidth = ko.observable(NaN);
    this.currentBandwidth = ko.observable(NaN);
    this.codec = ko.observable();

    this.show = function () {
      if (!ui.thisUser()) return;

      _this.update();

      _this.visible(true);
    };

    this.hide = function () {
      return _this.visible(false);
    };
  }

  _createClass(ConnectionInfo, [{
    key: "update",
    value: function update() {
      var client = this._ui.client;
      this.serverVersion(client.serverVersion);
      var dataStats = client.dataStats;

      if (dataStats) {
        this.latencyMs(dataStats.mean);
        this.latencyDeviation(Math.sqrt(dataStats.variance));
      }

      this.remoteHost(this._ui.remoteHost());
      this.remotePort(this._ui.remotePort());
      var spp = this._ui.settings.samplesPerPacket;
      var maxBitrate = client.getMaxBitrate(spp, false);
      var maxBandwidth = client.maxBandwidth;
      var actualBitrate = client.getActualBitrate(spp, false);
      var actualBandwidth = MumbleClient.calcEnforcableBandwidth(actualBitrate, spp, false);
      this.maxBitrate(maxBitrate);
      this.currentBitrate(actualBitrate);
      this.maxBandwidth(maxBandwidth);
      this.currentBandwidth(actualBandwidth);
      this.codec('Opus'); // only one supported for sending
    }
  }]);

  return ConnectionInfo;
}();

function CommentDialog() {
  var self = this;
  self.visible = ko.observable(false);

  self.show = function () {
    self.visible(true);
  };
}

var SettingsDialog = /*#__PURE__*/function () {
  function SettingsDialog(settings) {
    var _this2 = this;

    _classCallCheck(this, SettingsDialog);

    this.voiceMode = ko.observable(settings.voiceMode);
    this.pttKey = ko.observable(settings.pttKey);
    this.pttKeyDisplay = ko.observable(settings.pttKey);
    this.vadLevel = ko.observable(settings.vadLevel);
    this.testVadLevel = ko.observable(0);
    this.testVadActive = ko.observable(false);
    this.showAvatars = ko.observable(settings.showAvatars());
    this.userCountInChannelName = ko.observable(settings.userCountInChannelName()); // Need to wrap this in a pureComputed to make sure it's always numeric

    var audioBitrate = ko.observable(settings.audioBitrate);
    this.audioBitrate = ko.pureComputed({
      read: audioBitrate,
      write: function write(value) {
        return audioBitrate(Number(value));
      }
    });
    this.samplesPerPacket = ko.observable(settings.samplesPerPacket);
    this.msPerPacket = ko.pureComputed({
      read: function read() {
        return _this2.samplesPerPacket() / 48;
      },
      write: function write(value) {
        return _this2.samplesPerPacket(value * 48);
      }
    });

    this._setupTestVad();

    this.vadLevel.subscribe(function () {
      return _this2._setupTestVad();
    });
  }

  _createClass(SettingsDialog, [{
    key: "_setupTestVad",
    value: function _setupTestVad() {
      var _this3 = this;

      if (this._testVad) {
        this._testVad.end();
      }

      var dummySettings = new Settings({});
      this.applyTo(dummySettings);
      this._testVad = new VADVoiceHandler(null, dummySettings);

      this._testVad.on('started_talking', function () {
        return _this3.testVadActive(true);
      }).on('stopped_talking', function () {
        return _this3.testVadActive(false);
      }).on('level', function (level) {
        return _this3.testVadLevel(level);
      });

      testVoiceHandler = this._testVad;
    }
  }, {
    key: "applyTo",
    value: function applyTo(settings) {
      settings.voiceMode = this.voiceMode();
      settings.pttKey = this.pttKey();
      settings.vadLevel = this.vadLevel();
      settings.showAvatars(this.showAvatars());
      settings.userCountInChannelName(this.userCountInChannelName());
      settings.audioBitrate = this.audioBitrate();
      settings.samplesPerPacket = this.samplesPerPacket();
    }
  }, {
    key: "end",
    value: function end() {
      this._testVad.end();

      testVoiceHandler = null;
    }
  }, {
    key: "recordPttKey",
    value: function recordPttKey() {
      var _this4 = this;

      var combo = [];

      var keydown = function keydown(e) {
        combo = e.pressedKeys;
        var comboStr = combo.join(' + ');

        _this4.pttKeyDisplay('> ' + comboStr + ' <');
      };

      var keyup = function keyup() {
        keyboardjs.unbind('', keydown, keyup);
        var comboStr = combo.join(' + ');

        if (comboStr) {
          _this4.pttKey(comboStr).pttKeyDisplay(comboStr);
        } else {
          _this4.pttKeyDisplay(_this4.pttKey());
        }
      };

      keyboardjs.bind('', keydown, keyup);
      this.pttKeyDisplay('> ? <');
    }
  }, {
    key: "totalBandwidth",
    value: function totalBandwidth() {
      return MumbleClient.calcEnforcableBandwidth(this.audioBitrate(), this.samplesPerPacket(), true);
    }
  }, {
    key: "positionBandwidth",
    value: function positionBandwidth() {
      return this.totalBandwidth() - MumbleClient.calcEnforcableBandwidth(this.audioBitrate(), this.samplesPerPacket(), false);
    }
  }, {
    key: "overheadBandwidth",
    value: function overheadBandwidth() {
      return MumbleClient.calcEnforcableBandwidth(0, this.samplesPerPacket(), false);
    }
  }]);

  return SettingsDialog;
}();

var Settings = /*#__PURE__*/function () {
  function Settings(defaults) {
    _classCallCheck(this, Settings);

    var load = function load(key) {
      return window.localStorage.getItem('mumble.' + key);
    };

    this.voiceMode = load('voiceMode') || defaults.voiceMode;
    this.pttKey = load('pttKey') || defaults.pttKey;
    this.vadLevel = load('vadLevel') || defaults.vadLevel;
    this.toolbarVertical = load('toolbarVertical') || defaults.toolbarVertical;
    this.showAvatars = ko.observable(load('showAvatars') || defaults.showAvatars);
    this.userCountInChannelName = ko.observable(load('userCountInChannelName') || defaults.userCountInChannelName);
    this.audioBitrate = Number(load('audioBitrate')) || defaults.audioBitrate;
    this.samplesPerPacket = Number(load('samplesPerPacket')) || defaults.samplesPerPacket;
  }

  _createClass(Settings, [{
    key: "save",
    value: function save() {
      var save = function save(key, val) {
        return window.localStorage.setItem('mumble.' + key, val);
      };

      save('voiceMode', this.voiceMode);
      save('pttKey', this.pttKey);
      save('vadLevel', this.vadLevel);
      save('toolbarVertical', this.toolbarVertical);
      save('showAvatars', this.showAvatars());
      save('userCountInChannelName', this.userCountInChannelName());
      save('audioBitrate', this.audioBitrate);
      save('samplesPerPacket', this.samplesPerPacket);
    }
  }]);

  return Settings;
}();

var GlobalBindings = function GlobalBindings(config) {
  var _this5 = this;

  _classCallCheck(this, GlobalBindings);

  this.config = config;
  this.settings = new Settings(config.settings);
  this.detectWebRTC = false;
  this.webrtc = false;
  this.fallbackConnector = new WorkerBasedMumbleConnector();
  this.webrtcConnector = {
    connect: mumbleConnect
  };
  this.client = null;
  this.userContextMenu = new ContextMenu();
  this.channelContextMenu = new ContextMenu();
  this.connectDialog = new ConnectDialog();
  this.addChannelDialog = new AddChannelDialog();
  this.connectErrorDialog = new ConnectErrorDialog(this.connectDialog);
  this.connectionInfo = new ConnectionInfo(this);
  this.commentDialog = new CommentDialog();
  this.settingsDialog = ko.observable();
  this.minimalView = ko.observable(false);
  this.log = ko.observableArray();
  this.remoteHost = ko.observable();
  this.remotePort = ko.observable();
  this.thisUser = ko.observable();
  this.root = ko.observable();

  this.isHidden = function (user) {
    var n = String(user && user.name ? user.name() : '').toLowerCase();
    return n.indexOf('recorder') === 0 || n === 'superuser';
  };

  this.isSelf = function (user) {
    return user === _this5.thisUser();
  };

  this.loadRelatorios = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _document$getElementB, _document$getElementB2, _document$getElementB3;

    var body, filtro, de, ate, params, r, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = document.getElementById('relatorios-body');

            if (body) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            body.innerHTML = '<tr><td colspan="8" class="rel-empty">Carregando...</td></tr>';
            filtro = (((_document$getElementB = document.getElementById('rel-filtro')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value) || '').trim();
            de = (_document$getElementB2 = document.getElementById('rel-de')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value;
            ate = (_document$getElementB3 = document.getElementById('rel-ate')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.value;
            params = new URLSearchParams();
            if (de) params.set('from', de);
            if (ate) params.set('to', ate);
            if (filtro) params.set('q', filtro);
            params.set('page', 1);
            params.set('limit', 100);
            _context.prev = 13;
            _context.next = 16;
            return fetch(_this5.recordingBase + '/api/recordings/search?key=' + _this5.recordingKey + '&' + params.toString());

          case 16:
            r = _context.sent;

            if (r.ok) {
              _context.next = 19;
              break;
            }

            throw new Error('HTTP ' + r.status);

          case 19:
            _context.next = 21;
            return r.json();

          case 21:
            data = _context.sent;
            _this5.lastSearchItems = data.items || [];

            if (_this5.lastSearchItems.length) {
              _context.next = 26;
              break;
            }

            body.innerHTML = '<tr><td colspan="8" class="rel-empty">Nenhuma gravação encontrada. Ajuste os filtros e clique em Aplicar.</td></tr>';
            return _context.abrupt("return");

          case 26:
            body.innerHTML = _this5.lastSearchItems.map(function (rec) {
              var audioUrl = rec.audio_url || '';
              if (audioUrl && !/^https?:\/\//i.test(audioUrl)) audioUrl = _this5.recordingBase + audioUrl;
              if (audioUrl && audioUrl.indexOf('key=') === -1) audioUrl += (audioUrl.indexOf('?') === -1 ? '?' : '&') + 'key=' + _this5.recordingKey;
              return "\n        <tr>\n          <td><input type=\"checkbox\" class=\"rel-check\" data-id=\"".concat(rec.id, "\"\n").concat(_this5.selectedRecs.has(String(rec.id)) ? 'checked' : '', "\n               onchange=\"toggleRelSelect(this)\"></td>\n          <td>Grava\xE7\xE3o de PTT</td>\n          <td>").concat(rec.start || '', "</td>\n          <td>").concat(rec.user || '', "</td>\n          <td>").concat(rec.channel || '', "</td>\n          <td>").concat(rec.duration || 0, "</td>\n          <td>").concat(audioUrl ? '<audio controls preload="none" src="' + audioUrl + '"></audio>' : '<span class="rel-empty">—</span>', "</td>\n          <td>").concat(audioUrl ? '<button type="button" class="rel-dl" onclick="downloadRel(\'' + rec.id + '\')">⬇</button>' : '<span class="rel-empty">—</span>', "</td>\n        </tr>");
            }).join('');
            _context.next = 33;
            break;

          case 29:
            _context.prev = 29;
            _context.t0 = _context["catch"](13);
            console.warn('[Rel] falha na busca:', _context.t0);
            body.innerHTML = '<tr><td colspan="8" class="rel-empty">Erro ao buscar. Verifique o servidor e o console.</td></tr>';

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 29]]);
  }));

  this.desenharPontosGps = function (pontos) {
    // 2) Inicializar o mapa (Leaflet) uma única vez
    var el = document.getElementById('gps-map');
    if (!el) return;

    if (!_this5.gpsMap) {
      _this5.gpsMap = L.map(el).setView([-23.55, -46.63], 13); // centro inicial (SP)

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(_this5.gpsMap);
    } // 3) Limpar marcadores anteriores


    _this5.gpsMarkers.forEach(function (m) {
      return _this5.gpsMap.removeLayer(m);
    });

    _this5.gpsMarkers = [];

    if (!pontos || pontos.length === 0) {
      document.getElementById('gps-lista').innerHTML = '<em>Nenhum ponto GPS no período.</em>';
      return;
    } // 4) Desenhar cada ponto, numerado do 1º ao último


    pontos.forEach(function (p, i) {
      var num = i + 1;
      var marker = L.marker([p.lat, p.lng], {
        icon: L.divIcon({
          className: 'gps-num',
          html: '<div class="gps-num-badge">' + num + '</div>',
          iconSize: [24, 24],
          iconAnchor: [12, 12]
        })
      }).addTo(_this5.gpsMap); // Popup com localização + horário

      marker.bindPopup('<b>Ponto ' + num + '</b><br>' + 'Local: ' + (p.local || '—') + '<br>' + 'Horário: ' + (p.horario || '—') + '<br>' + 'Lat: ' + p.lat.toFixed(6) + ' | Lng: ' + p.lng.toFixed(6));

      _this5.gpsMarkers.push(marker);
    }); // 5) Ajustar o zoom para caber todos os pontos

    if (_this5.gpsMarkers.length > 1) {
      var group = L.featureGroup(_this5.gpsMarkers);

      _this5.gpsMap.fitBounds(group.getBounds().pad(0.1));
    } // 6) Lista abaixo do mapa


    var lista = document.getElementById('gps-lista');
    lista.innerHTML = pontos.map(function (p, i) {
      return '<div><b>' + (i + 1) + '.</b> ' + (p.local || '—') + ' — ' + (p.horario || '—') + ' <small>(' + p.lat.toFixed(5) + ', ' + p.lng.toFixed(5) + ')</small></div>';
    }).join('<br>');
  };

  this.msgDest = function (item) {
    if (!item) return '';
    if (item.type !== 'chat-message' && item.type !== 'chat-message-self') return '';
    var ch = ko.unwrap(item.channel); // desembrulha o channel (se observable)

    if (ch) {
      var nome1 = ko.unwrap(ch.name); // nome direto (ex.: modelo do canal)

      var model = ko.unwrap(ch.model); // desembrulha o wrapper PTT

      var nome2 = model ? ko.unwrap(model.name) : null;
      return ' → ' + (nome1 || nome2 || 'canal');
    }

    var usr = ko.unwrap(item.user);

    if (item.type === 'chat-message-self' && usr) {
      var nome = ko.unwrap(usr.name);
      return ' → ' + (nome || 'usuário');
    }

    return ' → privado';
  }; // ===== irmãos, no constructor =====


  this.relTipo = ko.observable('audio');

  this.onRelTipoChange = function () {
    if (_this5.relTipo() === 'audio') {
      _this5.loadRelatorios();
    } else {
      _this5.loadRelatoriosGps();
    }
  };

  this.gpsMap = null;
  this.gpsMarkers = [];
  this.gpsLine = null;
  this.buscarPontosGps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", [{
              lat: -23.5505,
              lng: -46.6333,
              horario: '2026-09-18 08:00',
              local: 'Ponto base'
            }, {
              lat: -23.5587,
              lng: -46.6254,
              horario: '2026-09-18 08:30',
              local: 'Av. Paulista'
            }, {
              lat: -23.5659,
              lng: -46.6480,
              horario: '2026-09-18 09:00',
              local: 'Centro'
            }]);

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  this.loadRelatoriosGps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var pontos, el, latlngs, lista;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this5.buscarPontosGps();

          case 2:
            pontos = _context3.sent;
            el = document.getElementById('gps-map');

            if (el) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return");

          case 6:
            if (!_this5.gpsMap) {
              _this5.gpsMap = L.map(el).setView([-23.55, -46.63], 13);
              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap'
              }).addTo(_this5.gpsMap);
            } // Limpa marcadores E a linha de execuções anteriores


            _this5.gpsMarkers.forEach(function (m) {
              return _this5.gpsMap.removeLayer(m);
            });

            _this5.gpsMarkers = [];

            if (_this5.gpsLine) {
              _this5.gpsMap.removeLayer(_this5.gpsLine);

              _this5.gpsLine = null;
            }

            if (!(!pontos || pontos.length === 0)) {
              _context3.next = 13;
              break;
            }

            document.getElementById('gps-lista').innerHTML = '<em>Nenhum ponto GPS no período.</em>';
            return _context3.abrupt("return");

          case 13:
            // Coordenadas na ordem (1º ao último) — a linha conecta nessa ordem
            latlngs = pontos.map(function (p) {
              return [p.lat, p.lng];
            }); // LINHA ligando os pontos

            _this5.gpsLine = L.polyline(latlngs, {
              color: '#e74c3c',
              weight: 3,
              opacity: 0.8,
              dashArray: '6, 6' // tracejado — remova para linha contínua

            }).addTo(_this5.gpsMap); // Marcadores numerados 1, 2, 3...

            pontos.forEach(function (p, i) {
              var num = i + 1;
              var marker = L.marker([p.lat, p.lng], {
                icon: L.divIcon({
                  className: 'gps-num',
                  html: '<div class="gps-num-badge">' + num + '</div>',
                  iconSize: [24, 24],
                  iconAnchor: [12, 12]
                })
              }).addTo(_this5.gpsMap);
              marker.bindPopup('<b>Ponto ' + num + '</b><br>' + 'Local: ' + (p.local || '—') + '<br>' + 'Horário: ' + (p.horario || '—') + '<br>' + 'Lat: ' + p.lat.toFixed(6) + ' | Lng: ' + p.lng.toFixed(6));

              _this5.gpsMarkers.push(marker);
            }); // Zoom para caber a linha inteira

            if (latlngs.length > 1) {
              _this5.gpsMap.fitBounds(L.latLngBounds(latlngs).pad(0.1));
            } else if (latlngs.length === 1) {
              _this5.gpsMap.setView(latlngs[0], 15);
            } // Lista numerada abaixo do mapa


            lista = document.getElementById('gps-lista');
            lista.innerHTML = pontos.map(function (p, i) {
              return '<div><b>' + (i + 1) + '.</b> ' + (p.local || '—') + ' — ' + (p.horario || '—') + ' <small>(' + p.lat.toFixed(5) + ', ' + p.lng.toFixed(5) + ')</small></div>';
            }).join('<br>');

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  this.toggleRelatorios = function () {
    // ← método irmão, NÃO aninhado
    var panel = document.getElementById('relatorios-container');
    if (!panel) return;
    var aberto = panel.style.display !== 'none';
    panel.style.display = aberto ? 'none' : 'flex';
    if (!aberto) _this5.loadRelatorios();
  };

  this.irParaNaoLida = function () {
    var mapC = document.getElementById('mapa-container');

    if (mapC) {
      mapC.style.display = 'none';
      _this5._mapaAberto = false;
    } // fecha o painel de relatórios se estiver aberto (o overlay esconde o chat)


    var relPanel = document.getElementById('relatorios-container');
    if (relPanel) relPanel.style.display = 'none'; // 1. canal com a não lida mais recente

    var best = null,
        bestTs = 0;
    Object.keys(_this5.unreadMeta).forEach(function (k) {
      if (_this5.unreadMeta[k].ts > bestTs) {
        bestTs = _this5.unreadMeta[k].ts;
        best = k;
      }
    }); // 2. sem não lidas → mantém o comportamento normal do botão (alterna o modo)

    if (best == null) {
      _this5.chatVisible(true); // ← adicione aqui (linha 636)


      if (_this5.messagesMode && _this5.messagesMode()) _this5.messagesMode(false);else if (_this5.messagesMode) _this5.messagesMode(true);
      return;
    } // 3. guarda a entry ANTES de selecionar (o subscribe de selected limpa o contador)


    var entry = _this5.unreadMeta[best].entry;

    var canal = _this5.canalPorId(best);

    if (String(best).indexOf('user:') === 0) {
      // não lida individual → abre a tela, preenche o remetente no campo de envio e zera o badge
      _this5.chatVisible(true);

      if (_this5.messagesMode && _this5.messagesMode() !== true) _this5.messagesMode(true); // preenche o campo de envio com o remetente da mensagem (em vez do canal)

      if (entry && entry.user) _this5.selected(entry.user);

      var cur = _this5.unreadCounts();

      var next = _objectSpread({}, cur);

      delete next[best];

      _this5.unreadCounts(next);

      delete _this5.unreadMeta[best];
      return;
    }

    if (!canal) return; // 4. abre a conversa do canal SEM mover o seu usuário (não interrompe o PTT)

    _this5.chatVisible(true);

    if (_this5.messagesMode && _this5.messagesMode() !== true) _this5.messagesMode(true);

    _this5.selected(canal); // zera o badge do canal via subscribe
    // 5. rola até o balão e destaca


    if (entry && entry.id != null) {
      setTimeout(function () {
        var el = document.querySelector('[data-entry-id="' + entry.id + '"]');

        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          el.classList.add('flash-unread');
          setTimeout(function () {
            return el.classList.remove('flash-unread');
          }, 3000);
        }
      }, 150);
    }
  }; // Lê a imagem selecionada e ENVIA imediatamente


  this.handleChatFile = function (input) {
    var file = input && input.files && input.files[0];
    if (!file) return; // Só aceita imagem

    if (!file.type || file.type.indexOf('image/') !== 0) {
      console.warn('[Chat] Anexo ignorado — só imagens:', file.type);
      input.value = '';
      return;
    }

    var reader = new FileReader();

    reader.onload = function (ev) {
      var dataUrl = ev.target.result; // data:image/...;base64,...
      // Monta a mensagem só com a imagem

      _this5.messageBox('<img src="' + dataUrl + '">'); // Envia imediatamente


      _this5.submitMessageBox();
    };

    reader.readAsDataURL(file);
    input.value = '';
  };

  window.handleChatFile = function (i) {
    return _this5.handleChatFile(i);
  }; // ===== Mensagens não lidas =====


  this.unreadCounts = ko.observable({}); // { idCanal: n }

  this.unreadMeta = {}; // idCanal -> { ts, entry }

  this.msgSeq = 0;
  this.telaMensagensAberta = ko.observable(false);
  this.totalUnread = ko.computed(function () {
    var c = _this5.unreadCounts();

    return Object.keys(c).reduce(function (acc, k) {
      return acc + (c[k] || 0);
    }, 0);
  }); // ... suas outras funções globais ...

  function buscarPontosGps() {
    return _buscarPontosGps.apply(this, arguments);
  }

  function _buscarPontosGps() {
    _buscarPontosGps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var resp;
      return _regeneratorRuntime.wrap(function _callee6$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return fetch('/api/gps?de=' + document.getElementById('gps-de').value + '&ate=' + document.getElementById('gps-ate').value);

            case 2:
              resp = _context8.sent;
              _context8.next = 5;
              return resp.json();

            case 5:
              return _context8.abrupt("return", _context8.sent);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee6);
    }));
    return _buscarPontosGps.apply(this, arguments);
  }

  this.unreadMeta = {}; // idCanal -> { ts, entry } (a última mensagem não lida)

  this.msgSeq = 0; // gerador de id das mensagens

  this.marcarNaoLida = function (ch, entry) {
    var id = chIdOf(ch);
    if (id == null) return; // só ignora se a tela de MENSAGENS estiver aberta no canal atual

    if (_this5.messagesMode && _this5.messagesMode() && id === _this5.currentChannelId()) return;

    var cur = _this5.unreadCounts();

    _this5.unreadCounts(_objectSpread(_objectSpread({}, cur), {}, _defineProperty({}, id, (cur[id] || 0) + 1)));

    _this5.unreadMeta[id] = {
      ts: Date.now(),
      entry: entry || null
    };
  };

  this.limparNaoLida = function (ch) {
    var id = chIdOf(ch);
    if (id == null) return;

    var cur = _this5.unreadCounts();

    if (!cur[id]) return;

    var next = _objectSpread({}, cur);

    delete next[id];

    _this5.unreadCounts(next);

    delete _this5.unreadMeta[id];
  };

  this.marcarNaoLidaUser = function (user, entry) {
    var uid = chIdOf(user);
    if (uid == null) return; // já está na tela de mensagens → a privada aparece no log, não marca

    if (_this5.messagesMode && _this5.messagesMode()) return;
    var key = 'user:' + uid;

    var cur = _this5.unreadCounts();

    _this5.unreadCounts(_objectSpread(_objectSpread({}, cur), {}, _defineProperty({}, key, (cur[key] || 0) + 1)));

    _this5.unreadMeta[key] = {
      ts: Date.now(),
      entry: entry || null
    };
  };

  this.limparNaoLidasPrivadas = function () {
    var cur = _this5.unreadCounts();

    var keys = Object.keys(cur).filter(function (k) {
      return k.indexOf('user:') === 0;
    });
    if (!keys.length) return;

    var next = _objectSpread({}, cur);

    keys.forEach(function (k) {
      delete next[k];
      delete _this5.unreadMeta[k];
    });

    _this5.unreadCounts(next);
  }; // Seleciona / desmarca TODAS as linhas da busca atual


  this.toggleRelSelectAll = function (cb) {
    var todas = document.querySelectorAll('#relatorios-body .rel-check');
    todas.forEach(function (linha) {
      linha.checked = cb.checked;
      var id = String(linha.dataset.id).trim();
      if (cb.checked) _this5.selectedRecs.add(id);else _this5.selectedRecs["delete"](id);
    });
    var btn = document.getElementById('rel-baixar-todos');
    if (btn) btn.disabled = _this5.selectedRecs.size === 0;
  };

  window.toggleRelSelectAll = function (cb) {
    return _this5.toggleRelSelectAll(cb);
  }; // Conjunto dos IDs selecionados


  this.selectedRecs = new Set();

  this.toggleRelSelect = function (cb) {
    var id = String(cb.dataset.id).trim();
    if (cb.checked) _this5.selectedRecs.add(id);else _this5.selectedRecs["delete"](id); // Sincroniza o checkbox "selecionar todas" do cabeçalho

    var todas = document.querySelectorAll('#relatorios-body .rel-check');
    var checkAll = document.getElementById('rel-check-all');

    if (checkAll) {
      checkAll.checked = todas.length > 0 && Array.from(todas).every(function (l) {
        return l.checked;
      });
    }

    var btn = document.getElementById('rel-baixar-todos');
    if (btn) btn.disabled = _this5.selectedRecs.size === 0;
  };

  window.toggleRelSelect = function (cb) {
    return _this5.toggleRelSelect(cb);
  }; // Baixa um arquivo e SEMPRE retorna uma Promise (resolve quando dispara ou falha)


  this.baixarUrl = function (url, nome) {
    return new Promise(function (resolve) {
      // Tenta via fetch → blob (força download mesmo cross-origin; precisa de CORS no servidor)
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.blob();
      }).then(function (blob) {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = nome || 'gravacao.mp3';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () {
          return URL.revokeObjectURL(a.href);
        }, 1000);
        resolve(); // ← sempre resolve
      })["catch"](function () {
        // Fallback: <a download> direto (funciona se a página for da mesma origem)
        var a = document.createElement('a');
        a.href = url;
        a.download = nome || 'gravacao.mp3';
        a.rel = 'noopener';
        document.body.appendChild(a);
        a.click();
        a.remove();
        resolve(); // ← sempre resolve
      });
    });
  };

  this.downloadRel = function (recIdRaw) {
    var recId = String(recIdRaw).trim();
    var rec = (_this5.lastSearchItems || []).find(function (r) {
      return String(r.id) === recId;
    });

    if (!rec) {
      console.warn('[Rel] não encontrada na busca:', recId);
      return;
    }

    var url = rec.audio_url || '';
    if (url && !/^https?:\/\//i.test(url)) url = _this5.recordingBase + url;
    if (url && url.indexOf('key=') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'key=' + _this5.recordingKey;
    var nome = '';

    try {
      var p = url.split('?')[0].split('/');
      nome = decodeURIComponent(p[p.length - 1] || '');
    } catch (_) {}

    if (!nome || !/\.\w+$/.test(nome)) nome = 'gravacao-' + recId + '.mp3';

    _this5.baixarUrl(url, nome);
  };

  window.downloadRel = function (id) {
    return _this5.downloadRel(id);
  };

  this.downloadAllRel = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var ids, montarUrl, montarNome, _iterator, _step, _loop, _ret, dir, ok, _loop2, _i, _ids, _ret2;

    return _regeneratorRuntime.wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            ids = Array.from(_this5.selectedRecs);

            if (ids.length) {
              _context6.next = 3;
              break;
            }

            return _context6.abrupt("return");

          case 3:
            montarUrl = function montarUrl(rec) {
              var url = rec.audio_url || '';
              if (url && !/^https?:\/\//i.test(url)) url = _this5.recordingBase + url;
              if (url && url.indexOf('key=') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'key=' + _this5.recordingKey;
              return url;
            };

            montarNome = function montarNome(rec, id) {
              var nome = '';

              try {
                var p = montarUrl(rec).split('?')[0].split('/');
                nome = decodeURIComponent(p[p.length - 1] || '');
              } catch (_) {}

              if (!nome || !/\.\w+$/.test(nome)) nome = 'gravacao-' + id + '.mp3';
              return nome;
            }; // Firefox / navegadores sem seletor de pasta: mantém o download um a um (Downloads)


            if (window.showDirectoryPicker) {
              _context6.next = 26;
              break;
            }

            _iterator = _createForOfIteratorHelper(ids);
            _context6.prev = 7;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var id, rec;
              return _regeneratorRuntime.wrap(function _loop$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      id = _step.value;
                      rec = (_this5.lastSearchItems || []).find(function (r) {
                        return String(r.id) === String(id);
                      });

                      if (rec) {
                        _context4.next = 5;
                        break;
                      }

                      console.warn('[Rel] não encontrada na busca:', id);
                      return _context4.abrupt("return", "continue");

                    case 5:
                      _context4.next = 7;
                      return _this5.baixarUrl(montarUrl(rec), montarNome(rec, id));

                    case 7:
                      _context4.next = 9;
                      return new Promise(function (r) {
                        return setTimeout(r, 900);
                      });

                    case 9:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _loop);
            });

            _iterator.s();

          case 10:
            if ((_step = _iterator.n()).done) {
              _context6.next = 17;
              break;
            }

            return _context6.delegateYield(_loop(), "t0", 12);

          case 12:
            _ret = _context6.t0;

            if (!(_ret === "continue")) {
              _context6.next = 15;
              break;
            }

            return _context6.abrupt("continue", 15);

          case 15:
            _context6.next = 10;
            break;

          case 17:
            _context6.next = 22;
            break;

          case 19:
            _context6.prev = 19;
            _context6.t1 = _context6["catch"](7);

            _iterator.e(_context6.t1);

          case 22:
            _context6.prev = 22;

            _iterator.f();

            return _context6.finish(22);

          case 25:
            return _context6.abrupt("return");

          case 26:
            _context6.prev = 26;
            _context6.next = 29;
            return window.showDirectoryPicker();

          case 29:
            dir = _context6.sent;
            _context6.next = 38;
            break;

          case 32:
            _context6.prev = 32;
            _context6.t2 = _context6["catch"](26);

            if (!(_context6.t2 && _context6.t2.name === 'AbortError')) {
              _context6.next = 37;
              break;
            }

            console.log('[Rel] pasta não selecionada');
            return _context6.abrupt("return");

          case 37:
            throw _context6.t2;

          case 38:
            ok = 0;
            _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2() {
              var id, rec, _url, res, blob, fileHandle, writable;

              return _regeneratorRuntime.wrap(function _loop2$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      id = _ids[_i];
                      rec = (_this5.lastSearchItems || []).find(function (r) {
                        return String(r.id) === String(id);
                      });

                      if (rec) {
                        _context5.next = 5;
                        break;
                      }

                      console.warn('[Rel] não encontrada na busca:', id);
                      return _context5.abrupt("return", "continue");

                    case 5:
                      _context5.prev = 5;
                      _url = montarUrl(rec);
                      _context5.next = 9;
                      return fetch(_url);

                    case 9:
                      res = _context5.sent;

                      if (res.ok) {
                        _context5.next = 12;
                        break;
                      }

                      throw new Error('HTTP ' + res.status);

                    case 12:
                      _context5.next = 14;
                      return res.blob();

                    case 14:
                      blob = _context5.sent;
                      _context5.next = 17;
                      return dir.getFileHandle(montarNome(rec, id), {
                        create: true
                      });

                    case 17:
                      fileHandle = _context5.sent;
                      _context5.next = 20;
                      return fileHandle.createWritable();

                    case 20:
                      writable = _context5.sent;
                      _context5.next = 23;
                      return writable.write(blob);

                    case 23:
                      _context5.next = 25;
                      return writable.close();

                    case 25:
                      ok++;
                      _context5.next = 31;
                      break;

                    case 28:
                      _context5.prev = 28;
                      _context5.t0 = _context5["catch"](5);
                      console.warn('[Rel] falha ao baixar', id, _context5.t0);

                    case 31:
                      _context5.next = 33;
                      return new Promise(function (r) {
                        return setTimeout(r, 900);
                      });

                    case 33:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _loop2, null, [[5, 28]]);
            });
            _i = 0, _ids = ids;

          case 41:
            if (!(_i < _ids.length)) {
              _context6.next = 49;
              break;
            }

            return _context6.delegateYield(_loop2(), "t3", 43);

          case 43:
            _ret2 = _context6.t3;

            if (!(_ret2 === "continue")) {
              _context6.next = 46;
              break;
            }

            return _context6.abrupt("continue", 46);

          case 46:
            _i++;
            _context6.next = 41;
            break;

          case 49:
            if (ok) alert('Download concluído: ' + ok + ' arquivo(s) na pasta ' + dir.name);

          case 50:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee4, null, [[7, 19, 22, 25], [26, 32]]);
  })); //window.downloadAllRel = () => this.downloadAllRel()
  // ===== Usuários online (percorre a árvore de canais) =====

  this.collectOnline = function () {
    var out = [];
    var seen = new Set();

    var consider = function consider(u) {
      if (!u) return;
      var m = u.model || u;
      var n = typeof u.name === 'function' ? u.name() : m && m.name;
      if (!n) return;
      if (n === 'SuperUser' || /^recorder/i.test(n)) return; // ignora bots/serviço

      if (seen.has(n)) return;
      seen.add(n);
      out.push({
        name: n,
        session: m && m.session
      });
    };

    var walk = function walk(ch) {
      if (!ch) return;
      if (typeof ch.users === 'function') ch.users().forEach(consider);
      if (typeof ch.channels === 'function') ch.channels().forEach(walk);
    };

    walk(_this5.root()); // inclui o Root (onde ficam usuários sem canal filho)

    return out;
  };

  this.onlineNamesFromMumble = function () {
    return new Set(_this5.collectOnline().map(function (x) {
      return x.name;
    }));
  };

  this.fecharRelatorios = function () {
    var panel = document.getElementById('relatorios-container');
    if (panel) panel.style.display = 'none';
  }; // devolve o id numérico do canal a partir de wrapper/observable/id


  function chIdOf(ch) {
    if (!ch) return null;
    if (typeof ch === 'function') ch = ch(); // ko.observable

    if (ch && _typeof(ch) === 'object') {
      if (ch.model) return ch.model._id != null ? ch.model._id : ch.model.id;
      if (ch.id != null) return ch.id;
      if (ch._id != null) return ch._id;
    }

    return ch; // já é número
  } // ===== Log: estado, filtro e derivados (declarado UMA vez) =====


  this.log = ko.observableArray();
  this.logLive = ko.observable(true);
  this.logFilter = ko.observable('');
  this.selectedLog = ko.observable(null);
  this.filteredLog = ko.computed(function () {
    var f = (_this5.logFilter() || '').toLowerCase();

    var items = _this5.log();

    if (_this5.messagesMode && _this5.messagesMode()) {
      items = items.filter(function (e) {
        return e.type === 'chat-message' || e.type === 'chat-message-self' || e.type === 'welcome-message';
      });
    }

    if (!f) return items;
    return items.filter(function (e) {
      var nomeUser = e.user && e.user.name ? typeof e.user.name === 'function' ? e.user.name() : e.user.name : '';
      var nomeCh = e.channel && e.channel.name ? typeof e.channel.name === 'function' ? e.channel.name() : e.channel.name : '';
      var hay = [e.type, e.value, e.message, nomeUser, nomeCh].join(' ').toLowerCase();
      return hay.indexOf(f) !== -1;
    });
  }); // ===== Log: ações dos botões =====

  this.toggleLogLive = function () {
    return _this5.logLive(!_this5.logLive());
  };

  this.clearLog = function () {
    return _this5.log.removeAll();
  };

  this.reloadLog = function () {
    _this5.logFilter('');

    _this5.logLive(true);
  };

  this.selectLogRow = function (entry) {
    _this5.selectedLog(_this5.selectedLog() === entry ? null : entry);
  }; // ===== Log: limpeza (só ao voltar do cache) =====


  this.resetLog = function () {
    _this5.log.removeAll();

    _this5.logFilter('');

    _this5.logLive(true);
  };

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) _this5.resetLog();
  }); // ===== Gravações no log (poll 5s; ordem crescente → a última fica visível no fim) =====

  this.recordingBase = '';
  this.recordingKey = 'sk-a1b2c3';
  this.recordingSeen = {};

  this.loadRecordings = function () {
    fetch(_this5.recordingBase + '/api/recordings?key=' + _this5.recordingKey + '&_=' + Date.now()).then(function (r) {
      return r.json();
    }).then(function (list) {
      list.sort(function (a, b) {
        return a.id - b.id;
      });
      list.forEach(function (rec) {
        var existing = _this5.log().find(function (e) {
          return e.type === 'recording' && e.recId === rec.id;
        });

        if (existing) {
          if (existing.status !== rec.status || existing.duration !== rec.duration || existing.size !== rec.size) {
            existing.status = rec.status;
            existing.duration = rec.duration;
            existing.size = rec.size;

            _this5.log.valueHasMutated();
          }

          return;
        }

        _this5.recordingSeen[rec.id] = true;

        _this5.log.push({
          type: 'recording',
          recId: rec.id,
          status: rec.status,
          message: 'Gravação de PTT',
          value: '',
          user: {
            name: ko.observable(rec.user || '')
          },
          channel: {
            name: ko.observable(rec.channel || '')
          },
          timestamp: rec.start,
          duration: rec.duration,
          size: rec.size,
          audioUrl: rec.audio_url
        });
      });
    })["catch"](function () {});
  };

  this.loadRecordings();
  setInterval(function () {
    return _this5.loadRecordings();
  }, 5000); // Classe da linha: self = enviada (direita), demais = recebida (esquerda)

  this.msgRowClass = function (e) {
    return e.type === 'chat-message-self' ? 'msg-self' : 'msg-in';
  }; // Mostra o remetente só em mensagens recebidas (na sua, já está implícito)
  // Mostra o remetente agora TAMBÉM nas mensagens enviadas por você


  this.msgShowSender = function (e) {
    return e.type === 'chat-message' || e.type === 'welcome-message' || e.type === 'chat-message-self';
  }; // Devolve o destino formatado (canal, usuário ou privado)


  this.msgDest = function (item) {
    if (!item) return '';
    if (item.type !== 'chat-message' && item.type !== 'chat-message-self') return '';
    var ch = ko.unwrap(item.channel);

    if (ch) {
      if (_typeof(ch) !== 'object') {
        // é id numérico → procura na árvore
        var _nome = _this5.nomePorChId(ch);

        return ' → ' + (_nome || '#' + ch);
      }

      var model = ko.unwrap(ch.model) || ch; // desembrulha wrapper/model

      var nome = ko.unwrap(model.name) || ko.unwrap(ch.name);
      return ' → ' + (nome || 'canal');
    }

    var usr = ko.unwrap(item.user);

    if (item.type === 'chat-message-self' && usr) {
      return ' → ' + (ko.unwrap(usr.name) || 'usuário');
    }

    return ' → privado';
  }; // Percorre a árvore procurando o canal pelo id (igual ao collectOnline)


  this.nomePorChId = function (id) {
    var found = null;

    var walk = function walk(ch) {
      if (!ch || found) return;
      var cid = chIdOf(ch);

      if (cid != null && String(cid) === String(id)) {
        var m = ch.model || ch;
        var n = typeof m.name === 'function' ? m.name() : m.name;
        if (n) found = n;
        return;
      }

      if (typeof ch.channels === 'function') ch.channels().forEach(walk);
    };

    walk(_this5.root());
    return found;
  }; // Percorre a árvore procurando o canal pelo id e retorna o próprio nó


  this.canalPorId = function (id) {
    var found = null;

    var walk = function walk(ch) {
      if (!ch || found) return;
      var cid = chIdOf(ch);

      if (cid != null && String(cid) === String(id)) {
        found = ch;
        return;
      }

      if (typeof ch.channels === 'function') ch.channels().forEach(walk);
    };

    walk(_this5.root());
    return found;
  }; // ===== Funções de renderização das linhas =====


  this.logRowClassName = function (entry) {
    var cls = 'log-row-' + (entry.type || 'generic');
    if (_this5.selectedLog() === entry) cls += ' log-row-selected';
    return cls;
  };

  this.logRowClass = function (e) {
    return 'log-row-' + (e.type || 'generic');
  };

  this.logIcon = function (e) {
    switch (e.type) {
      case 'chat-message':
        return '💬';

      case 'chat-message-self':
        return '✉️';

      case 'welcome-message':
        return '📢';

      case 'disconnect':
        return '🔌';

      case 'recording':
        return '🎙️';

      default:
        return '·';
    }
  };

  this.logTime = function (e) {
    if (e && e.timestamp) return e.timestamp;
    return '[' + new Date().toLocaleTimeString(navigator.language) + ']';
  };

  this.logSender = function (e) {
    if (e.user && e.user.name) return e.user.name();
    if (e.type === 'welcome-message') return 'Servidor';
    return 'Sistema';
  };

  this.logDest = function (e) {
    return e.channel && e.channel.name ? e.channel.name() : '';
  };

  this.logDescription = function (e) {
    if (e.type === 'recording') {
      if (e.status === 'recording') return '🎙️ Gravando…';
      var url = this.recordingBase + e.audioUrl + '?key=' + this.recordingKey;
      return '<audio controls controlsList="nodownload noplaybackrate" preload="none" src="' + url + '"></audio>';
    }

    if (e.message) return e.message;
    return e.value || '';
  };

  this.logDetail = function (e) {
    switch (e.type) {
      case 'recording':
        {
          var parts = [];
          if (e.duration) parts.push(e.duration + 's');
          if (e.size) parts.push((e.size / 1048576).toFixed(1) + ' MB');
          return parts.join(' · ') || 'Gravação';
        }

      case 'chat-message':
        return 'Mensagem de canal';

      case 'chat-message-self':
        return 'Mensagem enviada';

      case 'welcome-message':
        return 'Bem-vindo';

      case 'disconnect':
        return 'Conexão encerrada';

      default:
        return 'Sistema';
    }
  }; // ===== Autoscroll (uma única verificação; observa o tbody via initializeUI) =====


  this.logScrollToEnd = function () {
    if (!_this5.logLive()) return;
    var el = document.querySelector('.log-table-wrap');
    if (!el) return; // 1ª rolagem: imediata, após o DOM ser inserido

    el.scrollTop = el.scrollHeight;
    requestAnimationFrame(function () {
      el.scrollTop = el.scrollHeight;
    }); // após layout

    setTimeout(function () {
      el.scrollTop = el.scrollHeight;
    }, 120); // após áudio/imagem
  };

  this.log.subscribe(this.logScrollToEnd);
  this.filteredLog.subscribe(this.logScrollToEnd); // ===== Quem está falando (PTT) =====

  this.watchUserTalking = function (user) {
    user.talking.subscribe(function (state) {
      if (state !== 'off' && user.channel()) {
        _this5.recordTalker(user.channel(), user);
      }
    });
  }; // PTT: segurar para falar no canal, soltar para silenciar (mesmo mecanismo da tecla PTT)


  this.pttTalk = function (channel) {
    _this5.requestMove(_this5.thisUser(), channel); // entra no canal


    if (voiceHandler) voiceHandler._pushed = true; // aciona a transmissão (igual tecla PTT)
  }; // ✅ REGISTRA NO LOG — roda a CADA pressionada do PTT:
  //  this.log.push({
  // type: 'chat-message',
  //   value: 'PTT acionado no canal',
  //    user: { name: ko.observable('Você') },
  //    channel: { name: ko.observable(channel ? channel.name() : 'CANAL') },
  //    timestamp: Date.now()
  //  })
  //}


  this.pttRelease = function () {
    if (voiceHandler) {
      voiceHandler._stopOutbound(); // encerra o fluxo de áudio


      voiceHandler._pushed = false; // desativa a transmissão (igual soltar tecla)
    }
  }; // ===== PTT pelo atalho do teclado: estado "transmitindo agora" =====


  this.pttActive = ko.observable(false); // verdadeiro quando EU estou transmitindo no canal informado

  this.isCurrentChannelPttActive = function (channel) {
    return _this5.pttActive() && _this5.isCurrentChannel(channel);
  };

  this.listeningChannels = ko.observableArray([]);

  this.isListening = function (channel) {
    return _this5.listeningChannels().indexOf(channel) !== -1;
  };

  this.listenToChannel = function (channel) {
    var listen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var me = _this5.thisUser();

    if (!me || !channel) {
      console.warn('[LTC1] abortou: me ou channel ausente');
      return;
    }

    var chModel = channel.model ? channel.model : channel;
    var channelId = chModel && chModel._id != null ? chModel._id : null; // resolve a sessão por todos os caminhos possíveis

    var meModel = me.model ? me.model : me;
    var client = chModel && chModel._client ? chModel._client : _this5.client;
    var session = null;

    var tentar = function tentar(obj) {
      if (!obj || session != null) return;
      if (typeof obj.session !== 'undefined') session = obj.session;else if (typeof obj._session !== 'undefined') session = obj._session;
    };

    tentar(meModel);
    tentar(client && client.self);

    if (session == null && client && client._userById && client.self) {
      for (var k in client._userById) {
        if (client._userById[k] === client.self) {
          session = Number(k);
          break;
        }
      }
    }

    console.log('[LTC2] session =', session, '| channelId =', channelId, '| listen =', listen);

    if (channelId == null) {
      console.warn('[LTC1] abortou: channelId nulo');
      return;
    }

    var payload = {};
    if (session != null) payload.session = session;
    if (listen) payload.listening_channel_add = [channelId];else payload.listening_channel_remove = [channelId];
    var sender = client && typeof client._send === 'function' ? client : _this5.client && typeof _this5.client._send === 'function' ? _this5.client : null;
    console.log('[listen] UserState →', JSON.stringify(payload), '| _send é função?', !!sender);

    if (!sender) {
      console.error('[listen] nenhum cliente com _send encontrado');
      return;
    }

    try {
      sender._send({
        name: 'UserState',
        payload: payload
      });

      console.log('[listen] pacote entregue ao _send');
    } catch (e) {
      console.error('[listen] _send jogou erro:', e);
    }
  };

  this.unlistenChannel = function (channel) {
    if (!_this5.thisUser() || !channel) return;

    _this5.client._send({
      name: 'UserState',
      payload: {
        session: _this5.thisUser().model.session,
        listening_channel_remove: [channel.model._id] // ← só isso

      }
    });
  };

  this.toggleListen = function (channel) {
    // --- RASTREIO LOCAL (array de ids para o bloqueio no .on('voice')) ---
    if (!_this5._listeningChannels) _this5._listeningChannels = [];
    var cid = channel && channel.model ? channel.model._id : channel;

    var wasListening = _this5.isListening(channel);

    if (wasListening) {
      // desligar: remove o canal da escuta
      _this5.listenToChannel(channel, false);

      _this5.listeningChannels.remove(channel);

      _this5._listeningChannels = _this5._listeningChannels.filter(function (c) {
        return c !== cid;
      });
    } else {
      // ligar: adiciona o canal à escuta
      _this5.listenToChannel(channel);

      _this5.listeningChannels.push(channel);

      if (_this5._listeningChannels.indexOf(cid) === -1) _this5._listeningChannels.push(cid);
    }

    console.log('[toggleListen] channel =', channel, '| isListening =', wasListening, '| _listeningChannels =', JSON.stringify(_this5._listeningChannels));
  };

  this.mapInstance = null;
  this._focusUser = null; // ← adicionar

  this._mapaAberto = false; // ← estado inicial: mapa fechado

  this.markersLayer = null; // ===== NOVO: detecta se o mapa embutido está visível (estilo computado) =====

  this._mapaVisivel = function () {
    var c = document.getElementById('mapa-container');
    return !!c && getComputedStyle(c).display !== 'none';
  };

  this.clearMapFocus = function () {
    if (_this5._focusUser === null) return;
    _this5._focusUser = null; // redesenha os marcadores sem o círculo de foco e reativa o fitBounds do grupo

    if (_this5._mapaVisivel()) _this5.loadUserMarkers();
  };

  this.openMapa = function () {
    _this5.fecharRelatorios(); // ← ADICIONE ESTA LINHA


    var container = document.getElementById('mapa-container');
    if (!container) return; // Mapa JÁ aberto → fecha o mapa e abre os RÁDIOS

    if (_this5._mapaAberto) {
      container.style.display = 'none';
      _this5._mapaAberto = false;
      _this5._focusUser = null;

      _this5.chatVisible(true); // restaura o chat antes de abrir os rádios


      _this5.openRadios(); // ← abre os rádios


      return;
    } // Mapa fechado → abre o mapa


    container.style.display = 'block';
    _this5._mapaAberto = true;

    _this5.chatVisible(false);

    if (!_this5.mapInstance) {
      _this5.mapInstance = L.map('mapa-container').setView([-14.235, -51.925], 4);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(_this5.mapInstance);
      _this5.markersLayer = L.layerGroup().addTo(_this5.mapInstance);
      _this5._mapInteractedAt = 0;

      _this5.mapInstance.on('dragstart zoomstart', function () {
        _this5._mapInteractedAt = Date.now();
      });
    } else {
      setTimeout(function () {
        return _this5.mapInstance.invalidateSize();
      }, 100);
    }

    _this5.loadUserMarkers();

    if (!_this5.__mapaTimer) {
      _this5.__mapaTimer = setInterval(function () {
        return _this5.loadUserMarkers();
      }, 5000);
    }
  }; // Busca e desenha SÓ os usuários online no mapa embutido


  this.loadUserMarkers = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var onlineNames, res, users, online, key, byName, focado, m, interagindo, userActive;
    return _regeneratorRuntime.wrap(function _callee5$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            onlineNames = _this5.onlineNamesFromMumble();
            _context7.next = 4;
            return fetch('/api/locations/latest');

          case 4:
            res = _context7.sent;
            _context7.next = 7;
            return res.json();

          case 7:
            users = _context7.sent;

            _this5.markersLayer.clearLayers();

            online = users.filter(function (u) {
              return onlineNames.has(u.username);
            });
            key = online.map(function (u) {
              return u.username;
            }).sort().join('|'); // ===== NOVO: guarda o marcador de cada usuário para achar o focado =====

            byName = {};
            online.forEach(function (u) {
              var _u$accuracy_m, _u$speed_kmh, _u$heading_deg;

              var m = L.marker([u.latitude, u.longitude]).addTo(_this5.markersLayer);
              m.bindPopup('<b>' + u.username + '</b><br>' + 'Precisão: ' + ((_u$accuracy_m = u.accuracy_m) !== null && _u$accuracy_m !== void 0 ? _u$accuracy_m : '?') + ' m<br>' + 'Velocidade: ' + ((_u$speed_kmh = u.speed_kmh) !== null && _u$speed_kmh !== void 0 ? _u$speed_kmh : '?') + ' km/h<br>' + 'Direção: ' + ((_u$heading_deg = u.heading_deg) !== null && _u$heading_deg !== void 0 ? _u$heading_deg : '?') + '°<br>' + 'Atualizado: ' + u.reported_at);
              m.bindTooltip(u.username, {
                permanent: true,
                direction: 'top',
                offset: [0, -12]
              });
              byName[u.username] = m;
            }); // ===== NOVO: usuário pedido no "Buscar no mapa" =====

            focado = false;

            if (_this5._focusUser && byName[_this5._focusUser]) {
              m = byName[_this5._focusUser];
              L.circle(m.getLatLng(), {
                radius: 60,
                color: '#e74c3c',
                weight: 2,
                fillColor: '#e74c3c',
                fillOpacity: 0.15
              }).addTo(_this5.markersLayer);
              interagindo = Date.now() - (_this5._mapInteractedAt || 0) < 8000;

              if (!interagindo) {
                // mantém o zoom atual se já for mais próximo; senão vai para 16
                _this5.mapInstance.setView(m.getLatLng(), Math.max(_this5.mapInstance.getZoom(), 16));
              }

              m.openPopup();
              focado = true;
            } else if (_this5._focusUser) {
              console.warn('[mapa] foco pedido, mas sem posição online:', _this5._focusUser);
            }

            userActive = Date.now() - (_this5._mapInteractedAt || 0) < 8000; // ===== NOVO: com foco ativo, o auto-fit não rouba a câmera =====

            if (online.length > 0 && key !== _this5._lastMapKey && !userActive && !_this5._focusUser) {
              _this5.mapInstance.fitBounds(L.latLngBounds(online.map(function (u) {
                return [u.latitude, u.longitude];
              })), {
                padding: [30, 30]
              });
            }

            _this5._lastMapKey = key;
            _context7.next = 23;
            break;

          case 20:
            _context7.prev = 20;
            _context7.t0 = _context7["catch"](0);
            console.error('Erro ao carregar usuários no mapa:', _context7.t0);

          case 23:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee5, null, [[0, 20]]);
  })); // Desacopla o mapa em outra janela

  this.detachMapa = function () {
    window.open('mapa.html', '_blank', 'width=1000,height=700');

    _this5.openRadios(); // ← adiciona: abre os rádios junto
    // fecha o mapa embutido na janela principal


    var container = document.getElementById('mapa-container');
    var chatTop = document.querySelector('.chat-top');
    if (container) container.style.display = 'none';
    _this5._mapaAberto = false; // ← SINCRONIZA

    if (chatTop) chatTop.style.display = 'flex'; // ← botões de canal voltam
  };

  this.irParaNaoLida = function () {
    // fecha o painel de relatórios se estiver aberto (overlay esconde o chat)
    var relPanel = document.getElementById('relatorios-container');
    if (relPanel) relPanel.style.display = 'none'; // fecha o mapa embutido se estiver aberto (overlay cobre o chat)

    var mapC = document.getElementById('mapa-container');

    if (mapC) {
      mapC.style.display = 'none';
      _this5._mapaAberto = false;
    } // 1. canal com a não lida mais recente


    var best = null,
        bestTs = 0;
    Object.keys(_this5.unreadMeta).forEach(function (k) {
      if (_this5.unreadMeta[k].ts > bestTs) {
        bestTs = _this5.unreadMeta[k].ts;
        best = k;
      }
    }); // 2. sem não lidas → alterna o modo (comportamento normal do botão)

    if (best == null) {
      if (_this5.messagesMode && _this5.messagesMode()) _this5.messagesMode(false);else if (_this5.messagesMode) _this5.messagesMode(true);
      return;
    } // 3. guarda a entry ANTES de selecionar


    var entry = _this5.unreadMeta[best].entry;

    var canal = _this5.canalPorId(best); // 3a. não lida individual → abre a tela, preenche o remetente e zera o badge


    if (String(best).indexOf('user:') === 0) {
      _this5.chatVisible(true);

      if (_this5.messagesMode && _this5.messagesMode() !== true) _this5.messagesMode(true);
      if (entry && entry.user) _this5.selected(entry.user); // remetente no campo de envio

      var cur = _this5.unreadCounts();

      var next = _objectSpread({}, cur);

      delete next[best];

      _this5.unreadCounts(next);

      delete _this5.unreadMeta[best];
      return;
    }

    if (!canal) return; // 4. abre a conversa do canal SEM mover o seu usuário (não interrompe o PTT)

    _this5.chatVisible(true);

    if (_this5.messagesMode && _this5.messagesMode() !== true) _this5.messagesMode(true);

    _this5.selected(canal); // zera o badge do canal via subscribe

  };

  this.chatVisible = ko.observable(true);
  this.messagesMode = ko.observable(false);

  this.openMensagens = function () {
    _this5.limparNaoLidasPrivadas(); // zera os badges de privadas ao abrir


    var relPanel = document.getElementById('relatorios-container');
    if (relPanel) relPanel.style.display = 'none';
    var mapC = document.getElementById('mapa-container');

    if (mapC) {
      mapC.style.display = 'none';
      _this5._mapaAberto = false;
    }

    _this5._focusUser = null;

    _this5.chatVisible(true); // abre o painel


    _this5.messagesMode(true); // modo mensagens

  };

  this.openRadios = function () {
    _this5.fecharRelatorios(); // ← ADICIONE ESTA LINHA


    _this5.messagesMode(false); // sai do modo mensagens


    _this5.chatVisible(true); // garante o painel aberto
    // Fecha o mapa se estiver aberto


    var container = document.getElementById('mapa-container');

    if (container && container.style.display !== 'none') {
      container.style.display = 'none';
      _this5._mapaAberto = false; // sincroniza o estado

      _this5._focusUser = null;
    } // Garante que a lista de canais volte a aparecer


    var chatTop = document.querySelector('.chat-top');
    if (chatTop) chatTop.style.display = 'flex';
  }; // Lista plana de todos os canais (para os botões PTT)


  this.flatChannels = ko.pureComputed(function () {
    var out = [];

    var walk = function walk(c) {
      out.push(c);
      c.channels().forEach(walk);
    };

    var root = _this5.root();

    if (root) root.channels().forEach(walk); // ← percorre os filhos, NÃO o root

    return out;
  }); // Retorna true se algum usuário (deste canal ou subcanais) estiver falando

  this.channelHasTalker = function (channel) {
    var me = _this5.thisUser();

    if (channel.users().some(function (u) {
      return u !== me && u.talking() !== 'off';
    })) return true;
    return channel.channels().some(function (c) {
      return _this5.channelHasTalker(c);
    });
  };

  this.lastTalkerByChannel = ko.observable({});

  this.recordTalker = function (channel, user) {
    if (user && user.name && channel && channel.model) {
      var map = _this5.lastTalkerByChannel();

      map[channel.model._id] = user.name();

      _this5.lastTalkerByChannel(map); // ← notifica o Knockout

    }
  };

  this.lastTalker = function (channel) {
    var map = _this5.lastTalkerByChannel();

    var id = channel && channel.model ? channel.model._id : null;
    return id != null ? map[id] || '' : '';
  }; // ===== Canal atual (para destacar o botão do canal onde estou) =====


  this.currentChannelId = ko.pureComputed(function () {
    var me = _this5.thisUser();

    if (!me || typeof me.channel !== 'function') return null;
    var ch = me.channel();
    return ch ? chIdOf(ch) : null;
  });

  this.isCurrentChannel = function (channel) {
    var cur = _this5.currentChannelId();

    return cur != null && chIdOf(channel) === cur;
  };

  this.avatarView = ko.observable();

  var setDatasRel = function setDatasRel() {
    var hoje = new Date();

    var p = function p(n) {
      return String(n).padStart(2, '0');
    };

    var ymd = hoje.getFullYear() + '-' + p(hoje.getMonth() + 1) + '-' + p(hoje.getDate());
    var de = document.getElementById('rel-de');
    var ate = document.getElementById('rel-ate');
    if (de) de.value = ymd + 'T00:00';
    if (ate) ate.value = ymd + 'T23:59';
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setDatasRel);else setDatasRel();
  this.messageBox = ko.observable(''); // this.toolbarHorizontal = ko.observable(!this.settings.toolbarVertical)

  this.toolbarHorizontal = ko.observable(true); // padrão fixo: vertical

  this.settings.toolbarVertical = true; // mantém as duas fontes coerentes

  this.selected = ko.observable();
  this.selfMute = ko.observable(this.config.defaults.startMute);
  this.selfDeaf = ko.observable(this.config.defaults.startDeaf);
  this.selfMute.subscribe(function (mute) {
    if (voiceHandler) {
      voiceHandler.setMute(mute);
    }
  });

  this.submitOnEnter = function (data, e) {
    if (e.which == 13 && !e.shiftKey) {
      this.submitMessageBox();
      return false;
    }

    return true;
  };

  this.selected.subscribe(function (ch) {
    if (ch) _this5.limparNaoLida(ch);
  });

  this.toggleToolbarOrientation = function () {
    _this5.toolbarHorizontal(!_this5.toolbarHorizontal());

    _this5.settings.toolbarVertical = !_this5.toolbarHorizontal();

    _this5.settings.save();
  };

  this.select = function (element) {
    _this5.selected(element);
  };

  this.openSettings = function () {
    _this5.settingsDialog(new SettingsDialog(_this5.settings));
  };

  this.openAddChannel = function (user, channel) {
    _this5.addChannelDialog.parentID = channel.model._id;

    _this5.addChannelDialog.show();
  };

  this.addchannel = function (channelName) {
    var msg = {
      name: 'ChannelState',
      payload: {
        parent: _this5.addChannelDialog.parentID || 0,
        name: channelName
      }
    };

    _this5.client._send(msg);
  };

  this.ChannelRemove = function (user, channel) {
    var msg = {
      name: 'ChannelRemove',
      payload: {
        channel_id: channel.model._id
      }
    };

    _this5.client._send(msg);
  };

  this.applySettings = function () {
    var settingsDialog = _this5.settingsDialog();

    settingsDialog.applyTo(_this5.settings);

    _this5._updateVoiceHandler();

    _this5.settings.save();

    _this5.closeSettings();
  };

  this.closeSettings = function () {
    if (_this5.settingsDialog()) {
      _this5.settingsDialog().end();
    }

    _this5.settingsDialog(null);
  };

  this.getTimeString = function () {
    return '[' + new Date().toLocaleTimeString(navigator.language) + ']';
  };

  this.connect = function (username, host, port) {
    var tokens = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var password = arguments.length > 4 ? arguments[4] : undefined;
    var channelName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
    // if browser support Notification request permission
    if ('Notification' in window) Notification.requestPermission();

    _this5.resetClient();

    _this5.remoteHost(host);

    _this5.remotePort(port);

    log(translate('logentry.connecting'), host); // Note: This call needs to be delayed until the user has interacted with
    // the page in some way (which at this point they have), see: https://goo.gl/7K7WLu

    var ctx = audioContext();

    if (!_this5.webrtc) {
      _this5.fallbackConnector.setSampleRate(ctx.sampleRate);
    }

    if (!_this5._delayedMicNode) {
      _this5._micNode = ctx.createMediaStreamSource(_this5._micStream);
      _this5._delayNode = ctx.createDelay();
      _this5._delayNode.delayTime.value = 0.15;
      _this5._delayedMicNode = ctx.createMediaStreamDestination();
    } // TODO: token


    (_this5.webrtc ? _this5.webrtcConnector : _this5.fallbackConnector).connect("wss://".concat(host, ":").concat(port), {
      username: username,
      password: password,
      webrtc: _this5.webrtc ? {
        enabled: true,
        required: true,
        mic: _this5._delayedMicNode.stream,
        audioContext: ctx
      } : {
        enabled: false
      },
      tokens: tokens
    }).done(function (client) {
      log(translate('logentry.connected'));
      _this5.client = client; // Prepare for connection errors

      client.on('error', function (err) {
        log(translate('logentry.connection_error'), err);

        _this5.resetClient();
      }); // Make sure we stay open if we're running as Matrix widget

      if (window.matrixWidget) window.matrixWidget.setAlwaysOnScreen(true); // Register all channels, recursively 

      if (channelName.indexOf("/") != 0) {
        channelName = "/" + channelName;
      }

      var registerChannel = function registerChannel(channel, channelPath) {
        _this5._newChannel(channel);

        if (channelPath === channelName) {
          client.self.setChannel(channel);
        }

        channel.children.forEach(function (ch) {
          return registerChannel(ch, channelPath + "/" + ch.name);
        });
      };

      registerChannel(client.root, ""); // Register all users

      client.users.forEach(function (user) {
        return _this5._newUser(user);
      }); // Register future channels

      client.on('newChannel', function (channel) {
        return _this5._newChannel(channel);
      }); // Register future users

      client.on('newUser', function (user) {
        return _this5._newUser(user);
      }); // Handle messages

      client.on('message', function (sender, message, users, channels, trees) {
        console.log('[MSG RAW]', _typeof(message), message);
        var isImage = typeof message === 'string' && message.indexOf('data:image/') !== -1; // Destino = wrapper __ui do canal (igual ao sendMessage), com fallback seguro

        var canalRaw = channels && channels.length > 0 ? channels[0] : null;
        var canal = canalRaw ? canalRaw.__ui || {
          name: ko.observable(canalRaw.name || '')
        } : null;
        ui.log.push({
          type: 'chat-message',
          id: ++_this5.msgSeq,
          // ← novo: id único para o data-entry-id
          user: sender ? sender.__ui : null,
          channel: canal,
          message: isImage ? sanitize(message) : anchorme({
            input: sanitize(message),
            options: anchormeOptions
          })
        }); // ===== NÃO LIDAS =====

        if (canalRaw != null) {
          ui.marcarNaoLida(canalRaw, ui.log()[ui.log().length - 1]);
        } else if (sender && sender.__ui) {
          // mensagem individual/privada → marca por usuário
          ui.marcarNaoLidaUser(sender.__ui, ui.log()[ui.log().length - 1]);
        }
      }); // Log permission denied error messages

      client.on('denied', function (type) {
        ui.log.push({
          type: 'generic',
          value: 'Permission denied : ' + type
        });
      }); // Set own user and root channel

      _this5.thisUser(client.self.__ui);

      _this5.root(client.root.__ui); // Upate linked channels


      _this5._updateLinks(); // Log welcome message


      if (client.welcomeMessage) {
        _this5.log.push({
          type: 'welcome-message',
          message: sanitize(client.welcomeMessage)
        });
      } // Startup audio input processing


      _this5._updateVoiceHandler(); // Tell server our mute/deaf state (if necessary)


      if (_this5.selfDeaf()) {
        _this5.client.setSelfDeaf(true);
      } else if (_this5.selfMute()) {
        _this5.client.setSelfMute(true);
      }
    }, function (err) {
      if (err.$type && err.$type.name === 'Reject') {
        _this5.connectErrorDialog.type(err.type);

        _this5.connectErrorDialog.reason(err.reason);

        _this5.connectErrorDialog.show();
      } else if (err === 'server_does_not_support_webrtc' && _this5.detectWebRTC && _this5.webrtc) {
        log(translate('logentry.connection_fallback_mode'));
        _this5.webrtc = false;

        _this5.connect(username, host, port, tokens, password, channelName);
      } else {
        log(translate('logentry.connection_error'), err);
      }
    });
  };

  this._newUser = function (user) {
    var simpleProperties = {
      uniqueId: 'uid',
      username: 'name',
      mute: 'mute',
      deaf: 'deaf',
      suppress: 'suppress',
      selfMute: 'selfMute',
      selfDeaf: 'selfDeaf',
      texture: 'rawTexture',
      textureHash: 'textureHash',
      comment: 'comment'
    };
    var ui = user.__ui = {
      model: user,
      talking: ko.observable('off'),
      channel: ko.observable()
    };
    ui.texture = ko.pureComputed(function () {
      var raw = ui.rawTexture();
      if (!raw || raw.offset >= raw.limit) return null;
      return 'data:image/*;base64,' + ByteBuffer.wrap(raw).toBase64();
    });

    ui.show_avatar = function () {
      var setting = _this5.settings.showAvatars();

      switch (setting) {
        case 'always':
          break;

        case 'own_channel':
          if (_this5.thisUser().channel() !== ui.channel()) return false;
          break;

        case 'linked_channel':
          if (!ui.channel().linked()) return false;
          break;

        case 'minimal_only':
          if (!_this5.minimalView()) return false;
          if (_this5.thisUser().channel() !== ui.channel()) return false;
          break;

        case 'never':
        default:
          return false;
      }

      if (!ui.texture()) {
        if (ui.textureHash()) {
          // The user has an avatar set but it's of sufficient size to not be
          // included by default, so we need to fetch it explicitly now.
          // mumble-client should make sure we only send one request per hash
          user.requestTexture();
        }

        return false;
      }

      return true;
    };

    ui.openContextMenu = function (_, event) {
      return openContextMenu(event, _this5.userContextMenu, ui);
    };

    ui.canChangeMute = function () {
      return false; // TODO check for perms and implement
    };

    ui.canChangeDeafen = function () {
      return false; // TODO check for perms and implement
    };

    ui.canChangePrioritySpeaker = function () {
      return false; // TODO check for perms and implement
    };

    ui.canLocalMute = function () {
      return false; // TODO implement local mute
      // return this.thisUser() !== ui
    };

    ui.canIgnoreMessages = function () {
      return false; // TODO implement ignore messages
      // return this.thisUser() !== ui
    };

    ui.canChangeComment = function () {
      return false; // TODO implement changing of comments
      // return this.thisUser() === ui // TODO check for perms
    };

    ui.canChangeAvatar = function () {
      return _this5.thisUser() === ui; // TODO check for perms
    };

    ui.findOnMap = function () {
      var nome = ui.name();
      _this5._focusUser = nome; // abre o mapa embutido, se estiver fechado

      if (!_this5._mapaVisivel()) _this5.openMapa(); // 1ª pintura: o mapa precisa de um instante para ganhar tamanho (Leaflet)

      setTimeout(function () {
        if (_this5.markersLayer) _this5.loadUserMarkers();
      }, 300);
    };

    ui.toggleMute = function () {
      if (ui.selfMute()) {
        _this5.requestUnmute(ui);
      } else {
        _this5.requestMute(ui);
      }
    };

    ui.toggleDeaf = function () {
      if (ui.selfDeaf()) {
        _this5.requestUndeaf(ui);
      } else {
        _this5.requestDeaf(ui);
      }
    };

    ui.viewAvatar = function () {
      _this5.avatarView(ui.texture());
    };

    ui.changeAvatar = function () {
      var input = document.createElement('input');
      input.type = 'file';
      input.addEventListener('change', function () {
        var reader = new window.FileReader();

        reader.onload = function () {
          _this5.client.setSelfTexture(reader.result);
        };

        reader.readAsArrayBuffer(input.files[0]);
      });
      input.click();
    };

    ui.removeAvatar = function () {
      user.clearTexture();
    };

    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(user[key[0]]);
    });
    ui.state = ko.pureComputed(userToState, ui);

    if (user.channel) {
      ui.channel(user.channel.__ui);
      ui.channel().users.push(ui);
      ui.channel().users.sort(compareUsers);
    }

    user.on('update', function (actor, properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });

      if (properties.channel !== undefined) {
        if (ui.channel()) {
          ui.channel().users.remove(ui);
        }

        ui.channel(properties.channel.__ui);
        ui.channel().users.push(ui);
        ui.channel().users.sort(compareUsers);

        _this5._updateLinks();
      }

      if (properties.textureHash !== undefined) {
        // Invalidate avatar texture when its hash has changed
        // If the avatar is still visible, this will trigger a fetch of the new one.
        ui.rawTexture(null);
      }
    }).on('remove', function () {
      if (ui.channel()) {
        ui.channel().users.remove(ui);
      }
    }).on('voice', function (stream) {
      var t = stream && stream.target;
      ui.talking(t === 'whisper' || t === 2 ? 'whisper' : t === 'shout' || t === 1 ? 'shout' : 'on'); // canal de QUEM está falando (o `user` do closure é o falante)

      var talkerChId = chIdOf(user && user.channel);

      var refresh = function refresh() {
        if (ui._talkTimeout) clearTimeout(ui._talkTimeout);
        ui._talkTimeout = setTimeout(function () {
          return ui.talking('off');
        }, 400);
      };

      refresh();
      var userNode = null;

      var audibleNow = function audibleNow() {
        if (talkerChId == null) return false;

        var me = _this5.thisUser();

        var myId = chIdOf(me && me.channel);

        var listenIds = _this5.listeningChannels().map(function (c) {
          return chIdOf(c);
        });

        return talkerChId === myId || listenIds.indexOf(talkerChId) !== -1;
      };

      stream.on('data', function (data) {
        refresh();
        if (!audibleNow()) return; // canal não audível → descarta

        if (!userNode && !_this5.webrtc) {
          userNode = new BufferQueueNode({
            audioContext: audioContext()
          });
          userNode.connect(audioContext().destination);
        }

        if (userNode) userNode.write(data.buffer);
      }).on('end', function () {
        if (ui._talkTimeout) clearTimeout(ui._talkTimeout);
        ui.talking('off');
        if (userNode) userNode.end();
      });
    }); // ✅ AQUI, no FINAL da função _newUser — fora do if e fora do .on('voice')

    _this5.watchUserTalking(ui);
  };

  this._newChannel = function (channel) {
    var simpleProperties = {
      position: 'position',
      name: 'name',
      description: 'description'
    };
    var ui = channel.__ui = {
      model: channel,
      expanded: ko.observable(true),
      parent: ko.observable(),
      channels: ko.observableArray(),
      users: ko.observableArray(),
      linked: ko.observable(false)
    };

    ui.userCount = function () {
      return ui.channels().reduce(function (acc, c) {
        return acc + c.userCount();
      }, ui.users().length);
    };

    ui.openContextMenu = function (_, event) {
      return openContextMenu(event, _this5.channelContextMenu, ui);
    };

    ui.canJoin = function () {
      return true; // TODO check for perms
    };

    ui.canAdd = function () {
      return true; // TODO check for perms
    };

    ui.canEdit = function () {
      return false; // TODO check for perms and implement
    };

    ui.canRemove = function () {
      return true; // TODO check for perms
    };

    ui.canLink = function () {
      return false; // TODO check for perms and implement
    };

    ui.canUnlink = function () {
      return false; // TODO check for perms and implement
    };

    ui.canSendMessage = function () {
      return false; // TODO check for perms and implement
    };

    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(channel[key[0]]);
    });

    if (channel.parent) {
      ui.parent(channel.parent.__ui);
      ui.parent().channels.push(ui);
      ui.parent().channels.sort(compareChannels);
    }

    _this5._updateLinks();

    channel.on('update', function (properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });

      if (properties.parent !== undefined) {
        if (ui.parent()) {
          ui.parent().channel.remove(ui);
        }

        ui.parent(properties.parent.__ui);
        ui.parent().channels.push(ui);
        ui.parent().channels.sort(compareChannels);
      }

      if (properties.links !== undefined) {
        _this5._updateLinks();
      }
    }).on('remove', function () {
      if (ui.parent()) {
        ui.parent().channels.remove(ui);
      }

      _this5._updateLinks();
    });
  };

  this.resetClient = function () {
    if (_this5.client) {
      _this5.client.disconnect();
    }

    _this5.client = null;

    _this5.selected(null).root(null).thisUser(null);
  };

  this.connected = function () {
    return _this5.thisUser() != null;
  };

  this._updateVoiceHandler = function () {
    if (!_this5.client) {
      return;
    }

    if (voiceHandler) {
      voiceHandler.end();
      voiceHandler = null;
    }

    _this5.pttActive(false); // ← NOVO: não deixa o botão aceso ao trocar de modo ou reconectar


    var mode = _this5.settings.voiceMode;

    if (mode === 'cont') {
      voiceHandler = new ContinuousVoiceHandler(_this5.client, _this5.settings);
    } else if (mode === 'ptt') {
      voiceHandler = new PushToTalkVoiceHandler(_this5.client, _this5.settings);
    } else if (mode === 'vad') {
      voiceHandler = new VADVoiceHandler(_this5.client, _this5.settings);
    } else {
      log(translate('logentry.unknown_voice_mode'), mode);
      return;
    }

    voiceHandler.on('started_talking', function () {
      if (_this5.thisUser()) {
        _this5.thisUser().talking('on');
      }

      if (mode === 'ptt') {
        _this5.pttActive(true);

        playPttSound(); // ← NOVO
      }
    });
    voiceHandler.on('stopped_talking', function () {
      if (_this5.thisUser()) {
        _this5.thisUser().talking('off');
      }

      if (mode === 'ptt') {
        _this5.pttActive(false);

        pttSound.pause(); // ← NOVO (opcional)

        pttSound.currentTime = 0;
      }
    });

    if (_this5.selfMute()) {
      voiceHandler.setMute(true);
    }

    _this5._micNode.disconnect();

    _this5._delayNode.disconnect();

    if (mode === 'vad') {
      _this5._micNode.connect(_this5._delayNode);

      _this5._delayNode.connect(_this5._delayedMicNode);
    } else {
      _this5._micNode.connect(_this5._delayedMicNode);
    }

    _this5.client.setAudioQuality(_this5.settings.audioBitrate, _this5.settings.samplesPerPacket);
  };

  this.messageBoxHint = ko.pureComputed(function () {
    if (!_this5.thisUser()) {
      return ''; // Not yet connected
    }

    var target = _this5.selected();

    if (!target) {
      target = _this5.thisUser();
    }

    if (target === _this5.thisUser()) {
      target = target.channel();
    }

    if (target.users) {
      // Channel
      return translate('chat.channel_message_placeholder').replace('%1', target.name());
    } else {
      // User
      return translate('chat.user_message_placeholder').replace('%1', target.name());
    }
  });

  this.submitMessageBox = function () {
    _this5.sendMessage(_this5.selected(), _this5.messageBox());

    _this5.messageBox('');
  };

  this.sendMessage = function (target, message) {
    if (_this5.connected()) {
      // If no target is selected, choose our own user
      if (!target) {
        target = _this5.thisUser();
      } // If target is our own user, send to our channel


      if (target === _this5.thisUser()) {
        target = target.channel();
      } // Avoid blank message


      if (sanitize(message).trim().length == 0) return; // Support multiline

      message = message.replace(/\n\n+/g, "\n\n");
      message = message.replace(/\n/g, "<br>"); // Send message

      target.model.sendMessage(anchorme(message));

      if (target.users) {
        // Channel
        _this5.log.push({
          type: 'chat-message-self',
          message: anchorme({
            input: sanitize(message),
            options: anchormeOptions
          }),
          channel: target
        });
      } else {
        // User
        _this5.log.push({
          type: 'chat-message-self',
          message: anchorme({
            input: sanitize(message),
            options: anchormeOptions
          }),
          user: target
        });
      }
    }
  };

  this.openConversation = function (target) {
    if (!target) return;

    _this5.selected(target); // Mover o nosso usuário para o canal do alvo:
    // - alvo é CANAL   → vai para o próprio canal
    // - alvo é USUÁRIO → vai para o canal onde o usuário está


    var selfUi = _this5.thisUser();

    var selfMod = selfUi && selfUi.model || client.self;

    if (selfMod && typeof selfMod.setChannel === 'function') {
      var canalAlvo = null;

      if (target.users) {
        // Canal: usa o model do próprio canal
        canalAlvo = target.model || target;
      } else {
        // Usuário: resolve o canal onde ele está (mesmo acesso do messageBoxHint)
        var ch = ko.unwrap(target.channel);
        canalAlvo = ch ? ch.model || ch : null;
      }

      if (canalAlvo) {
        selfMod.setChannel(canalAlvo); // mesmo padrão do requestMove
      }
    }

    _this5.chatVisible(true);

    if (ko.isObservable(_this5.messagesMode)) _this5.messagesMode(true);
    var box = document.querySelector('#message-box') || document.querySelector('textarea');

    if (box) {
      box.focus();
      box.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };

  this.requestMove = function (user, channel) {
    if (_this5.connected()) {
      user.model.setChannel(channel.model);
      var currentUrl = url.parse(document.location.href, true); // delete search param so that query one can be taken into account

      delete currentUrl.search; // get full channel path

      if (channel.parent()) {
        // in case this channel is not Root
        var parent = channel.parent();
        currentUrl.query.channelName = channel.name();

        while (parent.parent()) {
          currentUrl.query.channelName = parent.name() + '/' + currentUrl.query.channelName;
          parent = parent.parent();
        }
      } else {
        // there is no channelName as we moved to Root
        delete currentUrl.query.channelName;
      } // reflect this change in URL


      window.history.pushState(null, channel.name(), url.format(currentUrl));
    }
  };

  this.requestMute = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfMute(true);
    }

    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfMute(true);
      } else {
        user.model.setMute(true);
      }
    }
  };

  this.requestDeaf = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfMute(true);

      _this5.selfDeaf(true);
    }

    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfDeaf(true);
      } else {
        user.model.setDeaf(true);
      }
    }
  };

  this.requestUnmute = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfMute(false);

      _this5.selfDeaf(false);
    }

    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfMute(false);
      } else {
        user.model.setMute(false);
      }
    }
  };

  this.requestUndeaf = function (user) {
    if (user === _this5.thisUser()) {
      _this5.selfDeaf(false);
    }

    if (_this5.connected()) {
      if (user === _this5.thisUser()) {
        _this5.client.setSelfDeaf(false);
      } else {
        user.model.setDeaf(false);
      }
    }
  };

  this._updateLinks = function () {
    if (!_this5.thisUser()) {
      return;
    }

    var allChannels = getAllChannels(_this5.root(), []);

    var ownChannel = _this5.thisUser().channel().model;

    var allLinked = findLinks(ownChannel, []);
    allChannels.forEach(function (channel) {
      channel.linked(allLinked.indexOf(channel.model) !== -1);
    });

    function findLinks(channel, knownLinks) {
      knownLinks.push(channel);
      channel.links.forEach(function (next) {
        if (next && knownLinks.indexOf(next) === -1) {
          findLinks(next, knownLinks);
        }
      });
      allChannels.map(function (c) {
        return c.model;
      }).forEach(function (next) {
        if (next && knownLinks.indexOf(next) === -1 && next.links.indexOf(channel) !== -1) {
          findLinks(next, knownLinks);
        }
      });
      return knownLinks;
    }

    function getAllChannels(channel, channels) {
      channels.push(channel);
      channel.channels().forEach(function (next) {
        return getAllChannels(next, channels);
      });
      return channels;
    }
  };

  this.openSourceCode = function () {
    var homepage = require('../package.json').homepage;

    window.open(homepage, '_blank').focus();
  };

  this.updateSize = function () {
    _this5.minimalView(window.innerWidth < 320);

    if (_this5.minimalView()) {
      _this5.toolbarHorizontal(false); // pequena → sempre vertical

    } else {
      _this5.toolbarHorizontal(!(_this5.settings.toolbarVertical !== false)); // default vertical

    }
  };
};

var ui = new GlobalBindings(window.mumbleWebConfig); // Used only for debugging

window.mumbleUi = ui;

function initializeUI() {
  var queryParams = url.parse(document.location.href, true).query;
  queryParams = Object.assign({}, window.mumbleWebConfig.defaults, queryParams);
  var useJoinDialog = queryParams.joinDialog;

  if (queryParams.matrix) {
    useJoinDialog = true;
  }

  if (queryParams.address) {
    ui.connectDialog.address(queryParams.address);
  } else {
    useJoinDialog = false;
  }

  if (queryParams.port) {
    ui.connectDialog.port(queryParams.port);
  } else {
    useJoinDialog = false;
  }

  if (queryParams.token) {
    var tokens = queryParams.token;

    if (!Array.isArray(tokens)) {
      tokens = [tokens];
    }

    ui.connectDialog.tokens(tokens);
  }

  if (queryParams.username) {
    ui.connectDialog.username(queryParams.username);
  } else {
    useJoinDialog = false;
  }

  if (queryParams.password) {
    ui.connectDialog.password(queryParams.password);
  }

  if (queryParams.webrtc !== 'auto') {
    ui.detectWebRTC = false;

    if (queryParams.webrtc == 'false') {
      ui.webrtc = false;
    }
  }

  if (queryParams.channelName) {
    ui.connectDialog.channelName(queryParams.channelName);
  }

  if (queryParams.avatarurl) {
    // Download the avatar and upload it to the mumble server when connected
    var _url2 = queryParams.avatarurl;
    console.log('Fetching avatar from', _url2);
    var req = new window.XMLHttpRequest();
    req.open('GET', _url2, true);
    req.responseType = 'arraybuffer';

    req.onload = function () {
      var upload = function upload(avatar) {
        if (req.response) {
          console.log('Uploading user avatar to server');
          ui.client.setSelfTexture(req.response);
        }
      }; // On any future connections


      ui.thisUser.subscribe(function (thisUser) {
        if (thisUser) {
          upload();
        }
      }); // And the current one (if already connected)

      if (ui.thisUser()) {
        upload();
      }
    };

    req.send();
  }

  ko.bindingHandlers.visibleUserCount = {
    update: function update(element, valueAccessor) {
      var channel = valueAccessor();
      var count = countVisible(channel);

      if (count === 0) {
        element.style.display = 'none';
      } else {
        element.style.display = '';
        element.textContent = ' (' + count + ')';
      }
    }
  };

  function countVisible(channel) {
    if (!channel) return 0;
    var own = 0;

    if (typeof channel.users === 'function') {
      own = channel.users().filter(function (u) {
        var n = String(u.name || '').toLowerCase();
        return n.indexOf('recorder') !== 0 && n !== 'superuser';
      }).length;
    }

    var kids = 0;

    if (typeof channel.channels === 'function') {
      kids = channel.channels().reduce(function (acc, c) {
        return acc + countVisible(c);
      }, 0);
    }

    return own + kids;
  }

  ui.connectDialog.joinOnly(useJoinDialog);
  ko.applyBindings(ui); // SÓ AQUI o DOM da tabela existe — observar o tbody é seguro

  var logTbody = document.querySelector('.log-table tbody');

  if (logTbody && !ui._logObserver) {
    ui._logObserver = new MutationObserver(function () {
      ui.logScrollToEnd();
    });

    ui._logObserver.observe(logTbody, {
      childList: true
    });
  } // ===== Botões do log — listeners nativos (não dependem do KO) =====


  var btnPause = document.getElementById('log-btn-pause');
  var btnClear = document.getElementById('log-btn-clear');
  var btnReload = document.getElementById('log-btn-reload');

  function updatePauseBtn() {
    if (!btnPause) return;
    var live = ui.logLive();
    btnPause.textContent = live ? '⏸ Pausar' : '▶ Seguir';
    btnPause.classList.toggle('active', live); // mantém o destaque se tiver .log-btn.active no SCSS
  }

  if (btnPause) btnPause.addEventListener('click', function () {
    ui.toggleLogLive();
    updatePauseBtn();
  });
  if (btnClear) btnClear.addEventListener('click', function () {
    ui.clearLog();
    updatePauseBtn();
  });
  if (btnReload) btnReload.addEventListener('click', function () {
    ui.reloadLog();
    updatePauseBtn();
  });
  updatePauseBtn();
  var btnDetach = document.getElementById('mapa-detach');
  if (btnDetach) btnDetach.addEventListener('click', function () {
    return ui.detachMapa();
  });

  window.onresize = function () {
    return ui.updateSize();
  };

  ui.updateSize();
}

function log() {
  console.log.apply(console, arguments);
  var args = [];

  for (var i = 0; i < arguments.length; i++) {
    args.push(arguments[i]);
  }

  ui.log.push({
    type: 'generic',
    value: args.join(' ')
  });
}

function compareChannels(c1, c2) {
  if (c1.position() === c2.position()) {
    return c1.name() === c2.name() ? 0 : c1.name() < c2.name() ? -1 : 1;
  }

  return c1.position() - c2.position();
}

function compareUsers(u1, u2) {
  return u1.name() === u2.name() ? 0 : u1.name() < u2.name() ? -1 : 1;
}

function userToState() {
  var flags = []; // TODO: Friend

  if (this.uid()) {
    flags.push('Authenticated');
  } // TODO: Priority Speaker, Recording


  if (this.mute()) {
    flags.push('Muted (server)');
  }

  if (this.deaf()) {
    flags.push('Deafened (server)');
  } // TODO: Local Ignore (Text messages), Local Mute


  if (this.selfMute()) {
    flags.push('Muted (self)');
  }

  if (this.selfDeaf()) {
    flags.push('Deafened (self)');
  }

  return flags.join(', ');
}

var voiceHandler;
var testVoiceHandler;
/**
 * @author svartoyg
 */

function translatePiece(selector, kind, parameters, key) {
  var element = document.querySelector(selector);

  if (element !== null) {
    var translation = translate(key);

    switch (kind) {
      default:
        console.warn('unhandled dom translation kind "' + kind + '"');
        break;

      case 'textcontent':
        element.textContent = translation;
        break;

      case 'attribute':
        element.setAttribute(parameters.name || 'value', translation);
        break;
    }
  } else {
    console.warn("translation selector \"".concat(selector, "\" for \"").concat(key, "\" did not match any element"));
  }
}
/**
 * @author svartoyg
 */


function translateEverything() {
  translatePiece('#connect-dialog_title', 'textcontent', {}, 'connectdialog.title');
  translatePiece('#connect-dialog_input_address', 'textcontent', {}, 'connectdialog.address');
  translatePiece('#connect-dialog_input_port', 'textcontent', {}, 'connectdialog.port');
  translatePiece('#connect-dialog_input_username', 'textcontent', {}, 'connectdialog.username');
  translatePiece('#connect-dialog_input_password', 'textcontent', {}, 'connectdialog.password');
  translatePiece('#connect-dialog_input_tokens', 'textcontent', {}, 'connectdialog.tokens');
  translatePiece('#connect-dialog_controls_remove', 'textcontent', {}, 'connectdialog.remove');
  translatePiece('#connect-dialog_controls_add', 'textcontent', {}, 'connectdialog.add');
  translatePiece('#connect-dialog_controls_cancel', 'attribute', {
    'name': 'value'
  }, 'connectdialog.cancel');
  translatePiece('#connect-dialog_controls_connect', 'attribute', {
    'name': 'value'
  }, 'connectdialog.connect');
  translatePiece('.connect-dialog.error-dialog .dialog-header', 'textcontent', {}, 'connectdialog.error.title');
  translatePiece('.connect-dialog.error-dialog .reason .refused', 'textcontent', {}, 'connectdialog.error.reason.refused');
  translatePiece('.connect-dialog.error-dialog .reason .version', 'textcontent', {}, 'connectdialog.error.reason.version');
  translatePiece('.connect-dialog.error-dialog .reason .username', 'textcontent', {}, 'connectdialog.error.reason.username');
  translatePiece('.connect-dialog.error-dialog .reason .userpassword', 'textcontent', {}, 'connectdialog.error.reason.userpassword');
  translatePiece('.connect-dialog.error-dialog .reason .serverpassword', 'textcontent', {}, 'connectdialog.error.reason.serverpassword');
  translatePiece('.connect-dialog.error-dialog .reason .username-in-use', 'textcontent', {}, 'connectdialog.error.reason.username_in_use');
  translatePiece('.connect-dialog.error-dialog .reason .full', 'textcontent', {}, 'connectdialog.error.reason.full');
  translatePiece('.connect-dialog.error-dialog .reason .clientcert', 'textcontent', {}, 'connectdialog.error.reason.clientcert');
  translatePiece('.connect-dialog.error-dialog .reason .server', 'textcontent', {}, 'connectdialog.error.reason.server');
  translatePiece('.connect-dialog.error-dialog .alternate-username', 'textcontent', {}, 'connectdialog.username');
  translatePiece('.connect-dialog.error-dialog .alternate-password', 'textcontent', {}, 'connectdialog.password');
  translatePiece('.connect-dialog.error-dialog .dialog-submit', 'attribute', {
    'name': 'value'
  }, 'connectdialog.error.retry');
  translatePiece('.connect-dialog.error-dialog .dialog-close', 'attribute', {
    'name': 'value'
  }, 'connectdialog.error.cancel');
  translatePiece('.join-dialog .dialog-header', 'textcontent', {}, 'joindialog.title');
  translatePiece('.join-dialog .dialog-submit', 'attribute', {
    'name': 'value'
  }, 'joindialog.connect');
  translatePiece('.user-context-menu .mute', 'textcontent', {}, 'usercontextmenu.mute');
  translatePiece('.user-context-menu .deafen', 'textcontent', {}, 'usercontextmenu.deafen');
  translatePiece('.user-context-menu .priority-speaker', 'textcontent', {}, 'usercontextmenu.priority_speaker');
  translatePiece('.user-context-menu .local-mute', 'textcontent', {}, 'usercontextmenu.local_mute');
  translatePiece('.user-context-menu .ignore-messages', 'textcontent', {}, 'usercontextmenu.ignore_messages');
  translatePiece('.user-context-menu .view-comment', 'textcontent', {}, 'usercontextmenu.view_comment');
  translatePiece('.user-context-menu .change-comment', 'textcontent', {}, 'usercontextmenu.change_comment');
  translatePiece('.user-context-menu .reset-comment', 'textcontent', {}, 'usercontextmenu.reset_comment');
  translatePiece('.user-context-menu .view-avatar', 'textcontent', {}, 'usercontextmenu.view_avatar');
  translatePiece('.user-context-menu .change-avatar', 'textcontent', {}, 'usercontextmenu.change_avatar');
  translatePiece('.user-context-menu .reset-avatar', 'textcontent', {}, 'usercontextmenu.reset_avatar');
  translatePiece('.user-context-menu .send-message', 'textcontent', {}, 'usercontextmenu.send_message');
  translatePiece('.user-context-menu .information', 'textcontent', {}, 'usercontextmenu.information');
  translatePiece('.user-context-menu .self-mute', 'textcontent', {}, 'usercontextmenu.self_mute');
  translatePiece('.user-context-menu .self-deafen', 'textcontent', {}, 'usercontextmenu.self_deafen');
  translatePiece('.user-context-menu .add-friend', 'textcontent', {}, 'usercontextmenu.add_friend');
  translatePiece('.user-context-menu .remove-friend', 'textcontent', {}, 'usercontextmenu.remove_friend');
  translatePiece('.channel-context-menu .join', 'textcontent', {}, 'channelcontextmenu.join');
  translatePiece('.channel-context-menu .add', 'textcontent', {}, 'channelcontextmenu.add');
  translatePiece('.channel-context-menu .edit', 'textcontent', {}, 'channelcontextmenu.edit');
  translatePiece('.channel-context-menu .remove', 'textcontent', {}, 'channelcontextmenu.remove');
  translatePiece('.channel-context-menu .link', 'textcontent', {}, 'channelcontextmenu.link');
  translatePiece('.channel-context-menu .unlink', 'textcontent', {}, 'channelcontextmenu.unlink');
  translatePiece('.channel-context-menu .unlink-all', 'textcontent', {}, 'channelcontextmenu.unlink_all');
  translatePiece('.channel-context-menu .copy-mumble-url', 'textcontent', {}, 'channelcontextmenu.copy_mumble_url');
  translatePiece('.channel-context-menu .copy-mumble-web-url', 'textcontent', {}, 'channelcontextmenu.copy_mumble_web_url');
  translatePiece('.channel-context-menu .send-message', 'textcontent', {}, 'channelcontextmenu.send_message');
  translatePiece('.toolbar .tb-horizontal', 'attribute', {
    'name': 'title'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-horizontal', 'attribute', {
    'name': 'alt'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-vertical', 'attribute', {
    'name': 'title'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-vertical', 'attribute', {
    'name': 'alt'
  }, 'toolbar.orientation');
  translatePiece('.toolbar .tb-connect', 'attribute', {
    'name': 'title'
  }, 'toolbar.connect');
  translatePiece('.toolbar .tb-connect', 'attribute', {
    'name': 'alt'
  }, 'toolbar.connect');
  translatePiece('.toolbar .tb-information', 'attribute', {
    'name': 'title'
  }, 'toolbar.information');
  translatePiece('.toolbar .tb-information', 'attribute', {
    'name': 'alt'
  }, 'toolbar.information');
  translatePiece('.toolbar .tb-mute', 'attribute', {
    'name': 'title'
  }, 'toolbar.mute');
  translatePiece('.toolbar .tb-mute', 'attribute', {
    'name': 'alt'
  }, 'toolbar.mute');
  translatePiece('.toolbar .tb-unmute', 'attribute', {
    'name': 'title'
  }, 'toolbar.unmute');
  translatePiece('.toolbar .tb-unmute', 'attribute', {
    'name': 'alt'
  }, 'toolbar.unmute');
  translatePiece('.toolbar .tb-deaf', 'attribute', {
    'name': 'title'
  }, 'toolbar.deaf');
  translatePiece('.toolbar .tb-deaf', 'attribute', {
    'name': 'alt'
  }, 'toolbar.deaf');
  translatePiece('.toolbar .tb-undeaf', 'attribute', {
    'name': 'title'
  }, 'toolbar.undeaf');
  translatePiece('.toolbar .tb-undeaf', 'attribute', {
    'name': 'alt'
  }, 'toolbar.undeaf');
  translatePiece('.toolbar .tb-record', 'attribute', {
    'name': 'title'
  }, 'toolbar.record');
  translatePiece('.toolbar .tb-record', 'attribute', {
    'name': 'alt'
  }, 'toolbar.record');
  translatePiece('.toolbar .tb-comment', 'attribute', {
    'name': 'title'
  }, 'toolbar.comment');
  translatePiece('.toolbar .tb-comment', 'attribute', {
    'name': 'alt'
  }, 'toolbar.comment');
  translatePiece('.toolbar .tb-settings', 'attribute', {
    'name': 'title'
  }, 'toolbar.settings');
  translatePiece('.toolbar .tb-settings', 'attribute', {
    'name': 'alt'
  }, 'toolbar.settings');
  translatePiece('.toolbar .tb-sourcecode', 'attribute', {
    'name': 'title'
  }, 'toolbar.sourcecode');
  translatePiece('.toolbar .tb-sourcecode', 'attribute', {
    'name': 'alt'
  }, 'toolbar.sourcecode');
} // ---- Feed do mapa: publica usuários online (sessão ativa no Mumble) ----


var _mapPush = function _mapPush() {
  var list = ui && typeof ui.collectOnline === 'function' ? ui.collectOnline() : [];
  var payload = {
    users: list,
    updatedAt: Date.now()
  };
  window.mumbleWebUsers = payload; // compartilha com o mapa.html em OUTRA aba (mesmo navegador/domínio)

  try {
    localStorage.setItem('mumbleWebUsers', JSON.stringify(payload));
  } catch (e) {}

  try {
    new BroadcastChannel('mumble-online').postMessage(payload);
  } catch (e) {}
};

setInterval(_mapPush, 2000);

function main() {
  return _main.apply(this, arguments);
} // ===== Relatório de GPS (escopo GLOBAL) =====


function _main() {
  _main = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var userMedia;
    return _regeneratorRuntime.wrap(function _callee7$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return localizationInitialize(navigator.language);

          case 2:
            translateEverything();
            _context9.prev = 3;
            _context9.next = 6;
            return initVoice(function (data) {
              if (testVoiceHandler) {
                testVoiceHandler.write(data);
              }

              if (!ui.client) {
                if (voiceHandler) {
                  voiceHandler.end();
                }

                voiceHandler = null;
              } else if (voiceHandler) {
                voiceHandler.write(data);
              }
            });

          case 6:
            userMedia = _context9.sent;
            ui._micStream = userMedia;
            _context9.next = 14;
            break;

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](3);
            window.alert('Failed to initialize user media\nRefresh page to retry.\n' + _context9.t0);
            return _context9.abrupt("return");

          case 14:
            initializeUI();

            _mapPush(); // ← primeiro preenchimento, com ui já pronta


          case 16:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee7, null, [[3, 10]]);
  }));
  return _main.apply(this, arguments);
}

window.carregarRadiosGps = function () {
  fetch('/api/locations/latest').then(function (r) {
    return r.json();
  }).then(function (lista) {
    var sel = document.getElementById('gps-radio');
    if (!sel) return;
    sel.innerHTML = '<option value="">— selecione —</option>' + lista.map(function (u) {
      return '<option value="' + u.username + '">' + u.username + '</option>';
    }).join('');
  })["catch"](function (err) {
    return console.error('Erro ao carregar rádios GPS:', err);
  });
};

window.gerarRelGps = function (formato) {
  var radio = document.getElementById('gps-radio').value;
  var de = document.getElementById('gps-de').value;
  var ate = document.getElementById('gps-ate').value;
  var status = document.getElementById('gps-status');

  if (!radio) {
    status.textContent = 'Selecione o rádio.';
    return;
  }

  if (!de || !ate) {
    status.textContent = 'Informe o período (De e Até).';
    return;
  }

  status.textContent = 'Gerando relatório...';
  var params = new URLSearchParams({
    radio: radio,
    inicio: de.replace('T', ' '),
    fim: ate.replace('T', ' '),
    entidade: 'InovaPTT',
    formato: formato
  });
  fetch('/api/report/gps?' + params.toString()).then(function (r) {
    if (!r.ok) {
      return r.json().then(function (e) {
        throw new Error(e.detalhe || e.error || 'Erro ao gerar relatório');
      });
    }

    return r.blob();
  }).then(function (blob) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'GPS_' + radio + '_' + de.slice(0, 10) + '.' + (formato === 'pdf' ? 'pdf' : 'xlsx');
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    status.textContent = 'Relatório gerado!';
  })["catch"](function (err) {
    status.textContent = 'Erro: ' + err.message;
    console.error(err);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.carregarRadiosGps);
} else {
  window.carregarRadiosGps();
}

window.loadRelatorios = function () {
  return ui.loadRelatorios();
};

window.downloadAllRel = function () {
  return ui.downloadAllRel();
};

window.toggleRelSelectAll = function (el) {
  return ui.toggleRelSelectAll(el);
};

window.toggleRelSelect = function (el) {
  return ui.toggleRelSelect(el);
};

window.handleChatFile = function (el) {
  return ui.handleChatFile(el);
};

window.toggleRelatorios = function () {
  return ui.toggleRelatorios();
};

window.downloadRel = function (id) {
  return ui.downloadRel(id);
};

window.loadRelatoriosGps = function () {
  return ui.loadRelatoriosGps();
};

window.onload = main;